import { Autocomplete, Box, Button, Checkbox, Chip, Divider, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Modal, Paper, Select, Stack, TextField, Tooltip, Typography } from '@mui/material'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { Demo_Layout_Default_JSON, Medical_History_Blood_Group } from '../../../../Utility/Constants';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import Webcam from "react-webcam";
import { Close } from '@material-ui/icons';
import { clearCachevalue, getCachevalue, setCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { CommonImgPreviewPop, CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { Colors } from '../../../../Styles/Colors';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { dataURItoFile } from '../../../../Components/CommonFunctions/CommonFunctions';
import Loader from '../../../../Components/Loader';
import moment from "moment";
import { City, Country, State } from 'country-state-city';
import PrintPreviewPop from '../../../../Components/Common Components/PrintPreviewPop';


const videoConstraints = {
  width: 500,
  height: 420,
  facingMode: "user",
  borderRadius: 100
};

class CreateApppointment extends Component {
  constructor(props) {
    super(props);
    this.webcamRef = React.createRef();
    this.state = {
      layoutData: [],
      mandotory_count: '03',
      refDoctorData: [],
      refSourceData: [],
      CorporateList: [],
      referredBy: "",
      referralSource: "",
      mobile_no: "",
      first_name: "",
      age: "",
      dob: null,
      gender: "",
      title: "",
      middle_name: "",
      surname: "",
      address_1: "",
      address_2: "",
      city: "",
      cityName: City.getCitiesOfState("IN", "TN"),
      country_code: 'IN',
      state_code: 'TN',
      AllCountry: Country.getAllCountries(),
      AllStates: State.getStatesOfCountry("IN"),
      pin_code: "",
      employer_id: "",
      employee_id: "",
      email_id: "",
      marital_status: "",
      father_husband_name: "",
      father_husband_age: "",
      occupation: "",
      emergency_contact_person: "",
      emergency_contact_mobile: "",
      relationship: "",
      docDocument: null,
      aadharProof: null,
      panProof: null,
      passportProof: null,
      rationProof: null,
      dlProof: null,
      aadharProofImg: null,
      panProofImg: null,
      passportProofImg: null,
      rationProofImg: null,
      dlProofImg: null,
      aadharProofImgCap: null,
      panProofImgCap: null,
      passportProofImgCap: null,
      rationProofImgCap: null,
      dlProofImgCap: null,
      doctorList: [],
      filteredDocList: [],
      spcInfo: [],
      tagDetails: [],
      AppointmentTypeList: [],
      selectedDocId: null,
      selectedSpecId: null,
      selectedTagId: null,
      selectedAppointTypeId: null,
      appointmentDateTime: new Date(),
      purposeOfVisit: "",
      MandatoryLabels: [],
      CorporateList: [],
      patient_img: null,
      temp_patient_img: null,
      ProfilePicClicked: false,
      pancard_number: "",
      ration_card_number: "",
      dl_number: "",
      passport_number: "",
      aadhar_card_number: "",
      SelectedPatientID: "",
      SelectedDocSRC: null,
      SameMobileNumPatients: [],
      isForIPUpdate: false,
      receive_email: false,
      receive_whatsapp: false,
      receive_sms: false,
      refDocumentSelected: null,
      insurance_company_name: null,
      policy_number: "",
      guardian: "",
      DateOpen: false,
      isPatientCreated: false,
      CreatedPatientId: null,
      createdBy: '',
      modifiedBy: '',
      NurseList: [],
      selectedNurseId: null,
      mother_name: "",
      mother_age: "",
      POVList: [],
      InsuranceList: [],
      NewInsurance: false,
      RequestedPatientData: {},
      DoctorPatientDetails: {},
      dateLimit: 90,
      dateLimitType: 'Days',
      manuallyChanged: false,
      doctorPatientId: null,
      isFrontCamera: true, 
      facingMode : 'user', 
      devices : [],
      selectedFatHusName:'',
      SelectedPatientType: null,
      PatientTypeConfig: false,
      patient_type: '',
      selectedPatientData: null,
      medicalBloodGroup: Medical_History_Blood_Group,
      blood_group: '',
      ccn_number: '',
      caretaker_id: '',
      pdfData: '',
      pdfPreview: false,
      duplicatedDocDocument:"",
      duplicateAadharProof:"",
      duplicatePanProof:"",
      duplicatePassportProof:"",
      duplicateRationProof:"",
      duplicateDlProof:"",
      OpthometristList: [],
      selectedOptometrist: null,
      hasAbha: localGetItem("has_abha_service") === "true" ? true : false,
      rchid:'',
      rchError: false,
    }
    this.uploadImage = React.createRef();
  }

  componentDidMount() {
    let city_name = localGetItem('city_name')
    let state_name = localGetItem('state_name')
    let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === state_name?.toLowerCase())
    let stateList = State.getStatesOfCountry(List?.countryCode)
    let cityList = City.getCitiesOfState(List?.countryCode, List?.isoCode)
    this.setState({ city: city_name, state_code: List?.isoCode, AllStates: stateList, cityName: cityList }, () => {
      this.getDemoLayout()
      this.getReferralDctorData()
      this.getRefSourceData()
      this.GetCorporateList()
      this._getTagDetails();
      this._getCorpList();
      this._getAppointTypeList()
      this.getInsuranceList()
      this.getQmsConfig()
      let userData = JSON.parse(localGetItem("loggedInUserInfo"))
      if(userData?.specialization_name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false"){
        this.getOpthometristList()
      }
      this.getConnectedDevices()
      let POVList = localGetItem("PurposeOfVisit") === null ? '[]' : localGetItem("PurposeOfVisit")
      let array = []
      JSON.parse(POVList)?.forEach(element => array.push(element.reason));
      if (array.length > 0) {
        this.setState({
          POVList: array,
          purposeOfVisit: userData?.purpose_of_visit ? userData?.purpose_of_visit : ''
        })
      }
      if (this.props.history?.location?.state?.AppointDate) {
        this.setState({
          appointmentDateTime: this.getDateTime(this.props.history?.location?.state?.AppointDate)
        }, () => { console.log(this.state.appointmentDateTime) })
      }
      let patient_type_config = JSON.parse(localGetItem("patient_type_config_in_demographics"))

      let patientDetails = this.props.fromOT ? getCachevalue("OTpatientData") : getCachevalue("DoctorPatientData");
      let patients = JSON.parse(patientDetails)
      let fromDoctorUpdate = this.props.history?.location?.state?.doctorUpdate
      let fromDemographic = getCachevalue('updatePatient')
      this.setState({ isQmsConfig: userData?.is_qms_enabled ? userData?.is_qms_enabled : false })
      if (fromDoctorUpdate) {
        this.LoaderFunction(true)
        this.setState({
          SelectedPatientID: patients?.patient_id
        }, () => { this.getPatientDemographics() })
      } else if (fromDemographic) {
        this.LoaderFunction(true)
        this.setState({
          SelectedPatientID: patients?.patient_id,
          appointmentId: patients?.appointment_id,
          SelectedPatientType: patients?.patient_type, PatientTypeConfig: patient_type_config ? patient_type_config : false, selectedPatientData: patients
        }, () => this.getPatientDemographics())
      }
      if (patients?.patient_id) {
        this.LoaderFunction(true)
        this.setState({ SelectedPatientID: patients?.patient_id }, () => { this.getPatientDemographics() })
      }
      if ((getCachevalue("AppRequestPatientData") && getCachevalue("AppRequestPatientData") !== JSON.stringify(this.state.RequestedPatientData))) {
        let Data = JSON.parse(getCachevalue("AppRequestPatientData"))
        this.setState({
          RequestedPatientData: Data,
          first_name: Data?.first_name ? Data?.first_name : "",
          mobile_no: Data?.mobile_number ? Data?.mobile_number : "",
          selectedAppointTypeId: Data?.appoinment_type ? Data?.Data?.appoinment_type : null,
          purposeOfVisit: Data?.message ? Data?.message : userData?.purpose_of_visit ? userData?.purpose_of_visit : "",
          appointmentDateTime: new Date(`${Data?.appointment_date} ${Data?.appointment_time}`),
          address_1: Data.address_line_1 ? Data.address_line_1 : "",
          address_2: Data.address_line_2 ? Data.address_line_2 : "",
          country_code: this.state.AllCountry?.find((item) => (item.name === Data?.country))?.isoCode,
          AllStates: State.getStatesOfCountry(this.state.AllCountry?.find((item) => (item.name === Data?.country))?.isoCode),
          state_code: State.getStatesOfCountry(this.state.AllCountry?.find((item) => (item.name === Data?.country))?.isoCode)?.find((item) => (item.name === Data?.state_name))?.isoCode,
          city: Data?.city_name ? Data?.city_name : "",
          pin_code: Data.pincode ? Data.pincode : null,
          age: Data.age ? Data.age : null,
          patient_type: Data?.patient_type ? Data?.patient_type : null,
        }, () => {
          let fromRequest = this.props?.history?.location?.state?.fromRequest
          if (Data?.age !== "") {
            this.setState({
              age: !fromRequest ? Data?.patient_age : Data?.age,
              dob: !fromRequest ? this.handleFindApproxDob(Data?.patient_age) : this.handleFindApproxDob(Data?.age)
            })
          }
          if (Data?.patient_id) {
            this.setState({
              SelectedPatientID: Data?.patient_id ? Data?.patient_id : ""
            }, () => {
              if (fromRequest) {
                this.LoaderFunction(true)
                this.getPatientDemographics()
              }
            })
          }
        })
      }
    })
  }


  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    }, ()=>{
      this.LoaderFunction(false)
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    }, ()=>{
      this.LoaderFunction(false)
    })
  }

  getPatientDemographics = (data) => {
    try {
      let fromDemographic = getCachevalue('updatePatient')
      this.LoaderFunction(true)
      let patient_id = data ? data : this.state.SelectedPatientID
      RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + "?patient_id=" + patient_id)
        .then(response => {
          if (response.data.status === "success") {
            this.assignDemographicsData(response.data.data)
            if (data && fromDemographic) {
              this.getDoctorDemographicsData()
            } else if (data) {
              let list = response?.data?.data;
              setCachevalue(JSON.stringify(list), 'DoctorPatientData')
              setCachevalue(JSON.stringify(list?.patient_id), 'DoctorPatientId')
            }
          }
        })
        .catch(error => {
          this.errorMessage(error.message)
        });
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getOpthometristList = () => {
      try {
        RestAPIService.getAll(Serviceurls.FO_OPTOMETRIST_LIST + `?only_available=true`).
          then((response) => {
            if (response.data.status === "success") {
              this.setState({
                OpthometristList: response.data.data,
              })
            }
            else {
              this.errorMessage(response.data.message)
            }
          }).catch((error) => {
            this.errorMessage(error.message)
          })
      } catch (e) {
        this.errorMessage(e.message)
      }
    }

  getDoctorDemographicsData = () => {
    try {

      RestAPIService.getAll(Serviceurls.FO_PATIENT_APPOINTMENT_DETAILS + '?appointment_id=' + this.state.appointmentId)
        .then((response) => {
          if (response.data.status === 'success') {
            let list = response?.data?.data;
            setCachevalue(JSON.stringify(list), 'DoctorPatientData')
            setCachevalue(JSON.stringify(list?.patient_id), 'DoctorPatientId')
          }
        }).catch(error => {
          this.errorMessage(error.message)
        });
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getInsuranceList = () => {
    try {
      let clinicId = getCachevalue('SelectedDoctorClinic')
      RestAPIService.getAll(Serviceurls.FO_INSURANCE_LIST + '?clinic_id=' + clinicId).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              InsuranceList: response.data.data,
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  // postNewInsurance = () => {
  //   var states = this.state

  //   var data = {
  //     "insurance_name": states.insurance_company_name
  //   }

  //   RestAPIService.create(data, Serviceurls.FO_INSURANCE_LIST)
  //     .then((response) => {
  //       if (response.data.status === 'success') {
  //       }
  //     }).catch((e) => {
  //       if (e?.response?.data?.message) {
  //         this.errorMessage(e.response.data.message)
  //       } else {
  //         this.errorMessage(e.message)
  //       }
  //     })
  // }

  getQmsConfig = () => {
    try {
      let clinicId = getCachevalue('SelectedDoctorClinic')
      RestAPIService.getAll(Serviceurls.QMS_CONFIG + '?clinic_id=' + clinicId)
        .then(response => {
          if (response?.data?.status === "success") {
            let data = response?.data?.data
            this.setState({
              dateLimit: data?.appointment_date_limit ? data?.appointment_date_limit : 90,
              dateLimitType: data?.duration_type ? data?.duration_type : 'Days',
            })
          }
        })
        .catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.errorMessage(error.response.data.message);
          } else {
            this.errorMessage(error?.message)
          }
        });
    } catch (e) {
      this.errorMessage(e.message);
    }
  }

  getDateTime = (date) => {
    var dateParts = date.split("-");
    var day = parseInt(dateParts[0]);
    var month = parseInt(dateParts[1]) - 1;
    var year = parseInt(dateParts[2]);

    var originalDate = new Date(year, month, day);
    var currentTime = new Date();
    originalDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
    return originalDate
  }

  assignDemographicsData(Datas) {
    try {
      this.setState({
        referredBy: Datas.reffered_by,
        referralSource: Datas.referral_source,
        mobile_no: Datas.mobile_number,
        first_name: Datas.first_name,
        age: this.handleAgeCalculation(Datas.dob !== null ? new Date(Datas?.dob) : new Date(Datas?.approx_dob)),
        dob: Datas.dob !== null ? new Date(Datas?.dob) : new Date(Datas?.approx_dob),
        gender: Datas.gender,
        title: Datas.title,
        middle_name: Datas.middle_name,
        surname: Datas.last_name,
        address_1: Datas.address_line_1,
        address_2: Datas.address_line_2,
        country_code: this.state.AllCountry.find((item) => (item.name === Datas?.country))?.isoCode,
        AllStates: State.getStatesOfCountry(this.state.AllCountry.find((item) => (item.name === Datas?.country))?.isoCode),
        state_code: State.getStatesOfCountry(this.state.AllCountry.find((item) => (item.name === Datas?.country))?.isoCode).find((item) => (item.name === Datas?.state_name))?.isoCode,
        city: Datas?.city_name,
        pin_code: Datas.pincode,
        employer_id: Datas.employer_id,
        employee_id: Datas.id_no,
        email_id: Datas.email,
        marital_status: Datas.marital_status,
        father_husband_name: Datas.father_husband_name,
        father_husband_age: Datas.father_husband_age ? Datas.father_husband_age : "",
        occupation: Datas.occupation,
        emergency_contact_person: Datas.caretaker_name,
        emergency_contact_mobile: Datas.caretaker_mobile,
        relationship: Datas.caretaker_relationship,
        duplicatedDocDocument: Datas.document_key === "" ? null : Datas.document_key,
        aadharProof: Datas.aadhar === "" ? null : Datas.aadhar,
        duplicateAadharProof: Datas.aadhar === "" ? null : Datas.aadhar,
        panProof: Datas.pan === "" ? null : Datas.pan,
        duplicatePanProof: Datas.pan === "" ? null : Datas.pan,
        passportProof: Datas.passport === "" ? null : Datas.passport,
        duplicatePassportProof: Datas.passport === "" ? null : Datas.passport,
        rationProof: Datas.ration_card === "" ? null : Datas.ration_card,
        duplicateRationProof: Datas.ration_card === "" ? null : Datas.ration_card,
        dlProof: Datas.dl === "" ? null : Datas.dl,
        duplicateDlProof: Datas.dl === "" ? null : Datas.dl,
        pancard_number: Datas.pancard_number,
        ration_card_number: Datas.ration_card_number,
        dl_number: Datas.dl_number,
        passport_number: Datas.passport_number,
        aadhar_card_number: Datas.aadhar_card_number,
        patient_img: Datas?.photo_url === "" ? null : Datas.photo_url,
        temp_patient_img: Datas?.photo_url === "" ? null : Datas.photo_url,
        receive_email: Datas?.receive_email,
        receive_whatsapp: Datas?.receive_whatsapp,
        receive_sms: Datas?.receive_sms,
        insurance_company_name: Datas?.insurance_company_name,
        policy_number: Datas?.policy_number,
        guardian: Datas?.guardian,
        createdBy: Datas?.created_by,
        modifiedBy: Datas?.modified_by,
        mother_name: Datas?.mother_name == null ? "" : Datas?.mother_name,
        mother_age: Datas?.mother_age == null ? "" : Datas?.mother_age,
        selectedFatHusName:Datas?.relationship_label ? Datas?.relationship_label : '',
        purposeOfVisit:  this.props.history?.location?.state?.fromCreate ? this.state.purposeOfVisit : Datas?.purpose_of_visit,
        patient_type: Datas?.patient_type ? Datas?.patient_type : null,
        blood_group: Datas?.blood_group ? Datas?.blood_group : '',
        ccn_number: Datas?.ccn_number ? Datas?.ccn_number : '',
        caretaker_id: Datas?.caretaker_id ? Datas?.caretaker_id : '',
        abha_health_id: Datas?.abha_health_id ? Datas?.abha_health_id : '',
        rchid: Datas?.rchid ? Datas?.rchid : '',

      }, () => {
        if(this.state.duplicatedDocDocument){
          this.getS3Key(this.state.duplicatedDocDocument , "docDocument")
        }
        if (this.state.duplicateAadharProof) {
          this.getS3Key(this.state.duplicateAadharProof , "aadharProof");
        }
        if (this.state.duplicatePanProof) {
          this.getS3Key(this.state.duplicatePanProof , "panProof");
        }
        if (this.state.duplicatePassportProof) {
          this.getS3Key(this.state.duplicatePassportProof, "passportProof");
        }
        if (this.state.duplicateRationProof) {
          this.getS3Key(this.state.duplicateRationProof , "rationProof");
        }
        if (this.state.duplicateDlProof) {
          this.getS3Key(this.state.duplicateDlProof , "dlProof");
        }
        this.setState({ cityName: City.getCitiesOfState(this.state.country_code, this.state.state_code) })
        this.LoaderFunction(false)
      })
    }
    catch (e) {
      this.LoaderFunction(false)
      this.errorMessage(e?.message)
    }
  }

  _getTagDetails = () => {
    try {
      let clinicId = getCachevalue('SelectedDoctorClinic')
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPPATIENTTAG + '?clinic_id=' + clinicId)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              tagDetails: response.data.data,
            });
          }
        })
        .catch(error => {
          this.errorMessage(error.message)
        });
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  _getCorpList = () => {
    try {
      let clinicId = getCachevalue('SelectedDoctorClinic')
      RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE + '?clinic_id=' + clinicId)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              CorporateList: response.data.data,
            });
          }
        })
        .catch(error => {
          this.errorMessage(error.message)
        });
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  _getAppointTypeList = () => {
    let clinicId = getCachevalue('SelectedDoctorClinic')
    RestAPIService.getAll(Serviceurls.FO_CONFIG_OPAPPOINTMENT + '?clinic_id=' + clinicId)
      .then(response => {
        if (response.data.status === "success") {
          this.setState({
            AppointmentTypeList: response.data.data.filter((item) => (item.is_active === true)),
          }, () => {
            if (Object.keys(this.state.RequestedPatientData).length > 0) {
              this.setState({
                selectedAppointTypeId: response.data.data.find((item) => (item.appoinment_type === "Telephonic Appointment"))
              })
            } else {
              this.setState({
                selectedAppointTypeId: response.data.data.find((item) => (item.appoinment_type === "Walk in Appointment" && item.is_active === true))
              })
            }
          });
        }
      })
      .catch(error => {
        this.errorMessage(error.message)
      });
  }

  getDemoLayout = () => {
    try {
      let clinicId = getCachevalue('SelectedDoctorClinic')
      this.LoaderFunction(true)
      RestAPIService.getAll(Serviceurls.FODemographicsLayout + '?clinic_id=' + clinicId)
        .then((response) => {
          if (response.data.status === "success") {
            var Data = response.data.data
            var len = Data.length
            this.setState({
              layoutData: Data[len - 1] ? Data[len - 1].field_order : Demo_Layout_Default_JSON,
              mandotory_count: Data[len - 1] ? ("0" + Data[len - 1].mandatory_field_count) : '04',
            }, () => {
              let MandLabels = []
              for (let i = 0; i < +this.state.mandotory_count; i++) {
                MandLabels.push(this.state.layoutData[i].label)
              }
              this.setState({ MandatoryLabels: MandLabels }, () => { this.LoaderFunction(false) })
            })
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })

    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  getReferralDctorData = () => {
    try {
      let clinicId = getCachevalue('SelectedDoctorClinic')
      RestAPIService.getAll(Serviceurls.DOC_REFERRAL_DOCTOR + '?clinic_id=' + clinicId).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              refDoctorData: response.data.data
            })
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getRefSourceData = () => {
    try {
      let clinicId = getCachevalue('SelectedDoctorClinic')
      RestAPIService.getAll(Serviceurls.DOC_REFERRAL_SOURCE + '?clinic_id=' + clinicId).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              refSourceData: response.data.data
            })
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })

    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  GetCorporateList() {
    try {
      let clinicId = getCachevalue('SelectedDoctorClinic')
      RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE + '?clinic_id=' + clinicId).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              CorporateList: response.data.data
            })
          }
          else {
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  CheckExistingPatients() {
    try {
      let clinicId = getCachevalue('SelectedDoctorClinic')
      RestAPIService.getAll(Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.mobile_no}&address_key=&father_husband_key=&clinic_id=${clinicId}`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              SameMobileNumPatients: response.data.data
            })
          }
          else {
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  toggleIdCameraButton = (key) => {
    this.setState({
      isFrontCamera: !this.state.isFrontCamera,
      [key]: null
    }, () => { this.videoConstraints() })
  }

  OpenWebCamIdPopUP = () => {
    const { slcIdKey } = this.state;
    const key = slcIdKey?.replace("Img", "");
    try {
      return (
        <Box>
          <Modal open={true}>
            <Box className="eMed_WebCamPop_Main">
              <Box component={'div'} className="eMed_WebCam_Header">
                <Typography variant='h6'>{"Capture Image"}</Typography>
                <Button onClick={() => {
                  this.setState((prevState) => ({
                    [slcIdKey]: prevState[slcIdKey + "Cap"],
                    imgCapClked: false
                  }))
                }} >
                  <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                </Button>
              </Box>
              <Box component={'div'}>
                {
                  this.state[slcIdKey] === null ?
                    <Webcam
                      className='eMed_WebCam_Div'
                      audio={false}
                      mirrored={this.state.isFrontCamera}
                      ref={this.webcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={this.videoConstraints()}
                    /> :
                    <img className='eMed_WebCam_Img_Div' src={this.state[slcIdKey]} />
                }
              </Box>
              <Box component={'div'} className="eMed_WebCam_Btn_div" width={"70%"} mr={"3vw"} ml={"7vw"}>
                <Button disabled={this.state[slcIdKey] !== null} variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ [slcIdKey]: this.webcamRef.current.getScreenshot() }) }}>Capture</Button>
                <Button variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ [slcIdKey]: null }) }}>Retake</Button>
                <Button disabled={this.state[slcIdKey] === null} variant='contained' size='small' id="eMed_Config_btn"
                  onClick={() => {
                    this.setState((prevState) => ({
                      [slcIdKey + "Cap"]: dataURItoFile(prevState[slcIdKey], slcIdKey?.replace("Img", ".jpg")),
                      [key]: null,
                      imgCapClked: false
                    }))
                  }}>Add Image</Button>
                {this.state.devices?.length > 1 && <Button variant='contained' size='small' id="eMed_Config_btn" sx={{ width: '10.5vw' }} onClick={() => { this.toggleIdCameraButton() }} >
                  Switch to {this.state.isFrontCamera ? "Back" : "Front"} Camera
                </Button>}
              </Box>
            </Box>
          </Modal>
        </Box>
      );
    } catch (e) { }
  };

  alphaValidation = (num) => {
    return !/[^A-Z a-z]+/.test(num)
  }
  numberValidation(num) {
    return /^\d+$/.test(num);
  }

  handleAgeCalculation = date => {
    // let age = "";
    // let dob = DateTime.fromJSDate(date);
    // var year_age = DateTime.now().diff(dob, 'years');
    // age = Math.floor(year_age.years) || 0;
    // return (date < new Date() && date > new Date("1872-01-01")) ? age : "";
    let age = "";
    let dob = new Date(date);
    let m = moment(dob, "DD-MM-YYYY");
    var end_date = moment();

    var year_age = end_date.diff(m, 'year') || 0;
    // reset(year) year with difference year
    m = moment(m).add(year_age, 'years');

    var month_age = end_date.diff(m, 'month') || 0;
    // reset(month) month with difference month
    m = moment(m).add(month_age, 'months');

    var day_age = end_date.diff(m, 'days') || 0;

    if (year_age > 0) {
      age = year_age || 0;
    } else {
      age = year_age + "Y/" + month_age + "M/" + day_age + "D";
    }
    return (date < new Date() && date > new Date("1872-01-01")) ? age : "";
  }

  handleFindApproxDob = ageEntered => {

    var year = 0;
    var month = 0;
    var days = 0;
    var tempDate;
    year = +(ageEntered)
    if (!year) {
      tempDate = null;
    } else {
      tempDate = DateTime.now().minus({ years: year }).toBSON();
    }

    return tempDate;
  }
  getPincodeToCity = (pincode) => {
    fetch("https://api.postalpincode.in/pincode/" + pincode)
      .then((res) => res.json())
      .then(response => {
        if (response && response[0].Status == "Success") {
          var data = response[0].PostOffice
          if (data && data.length > 0) {
            this.setState({
              city: this.state?.city ? this.state?.city : data[0].District,
              state: this.state?.state ? this.state?.state : data[0].State,
              country: this.state?.country ? this.state?.country : data[0].Country
            })
          }
        } else if (response.data.status == "fail") {
        }
      })
      .catch(e => {
      });
  }
  renderInput = (data, type) => {
    var states = this.state
    const { t } = this.props
    const AbhaDisable = (states.SelectedPatientID && (this.state.abha_health_id) && this.state.hasAbha) ? true : false

    const fieldName = data.field_name.replace(/([A-Z])/g, '_$1').toLowerCase();
    const emedTid = `doc_demographics_${fieldName}`;
    return (
      <form emed_tid={`${emedTid}_form`}>
        <Box sx={{ marginTop: '2.5vh', marginLeft: '1vw', width: (data.label == "Age" || data.label == "Title") ? '7vw' : '12vw' }} emed_tid={`${emedTid}_box`}>
          {data.label == "Date of Birth" ?
            <LocalizationProvider dateAdapter={AdapterDateFns} emed_tid={`${emedTid}_date_provider`}>
              <DatePicker
                label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                disabled={AbhaDisable || false}
                inputFormat={"dd-MM-yyyy"}
                autoComplete="off"
                value={states[data.field_name]}
                minDate={new Date("1872-01-01")}
                maxDate={DateTime.now()}
                emed_tid={`${emedTid}_date_picker`}
                onChange={(newDate) => {
                  var age = this.handleAgeCalculation(newDate)
                  this.setState({
                    dob: newDate,
                    age: age
                  })
                }}
                renderInput={(params) => <TextField {...params} size='small' autoComplete="off"
                  variant="outlined" fullWidth emed_tid={`${emedTid}_input`} />}
              />
            </LocalizationProvider>
            :
            data.label == "Title" ?
              <FormControl size='small' fullWidth sx={{ textAlign: 'center', height: '1.3vw' }} emed_tid={`${emedTid}_form_control`}>
                <InputLabel id="title-select-label" emed_tid={`${emedTid}_label`}>{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                <Select
                  labelId="title-select-label"
                  MenuProps={{ style: { maxHeight: 250 } }}
                  size='small'
                  sx={{ fontSize: '0.8vw', }}
                  value={states[data.field_name]}
                  label={t(data.label)}
                  emed_tid={`${emedTid}_select`}
                  onChange={(e) => {
                    states[data.field_name] = e.target.value

                    this.setState({
                      states
                    }, () => {
                      var states = this.state
                      if (states.title == "Mr") {
                        states["gender"] = "m";
                      } else if (states.title == "Ms") {
                        states["gender"] = "f";
                      } else if (states.title == "Mrs") {
                        states["gender"] = "f";
                        states["marital_status"] = "Married"
                        states["manuallyChanged"] = true
                      } 
                      if(states.manuallyChanged && states.title !== "Mrs") {
                        states["marital_status"] = ""
                      }
                      this.setState({ states })
                    })
                  }}
                >
                  <MenuItem value={""} emed_tid={`${emedTid}_option_empty`}>{"Title"}</MenuItem>
                  <MenuItem value={"Dr"} emed_tid={`${emedTid}_option_dr`}>{"Dr"}</MenuItem>
                  <MenuItem value={"Mr"} emed_tid={`${emedTid}_option_mr`}>{"Mr"}</MenuItem>
                  <MenuItem value={"Ms"} emed_tid={`${emedTid}_option_ms`}>{"Ms"}</MenuItem>
                  <MenuItem value={"Mrs"} emed_tid={`${emedTid}_option_mrs`}>{"Mrs"}</MenuItem>
                  <MenuItem value={"Master"} emed_tid={`${emedTid}_option_master`}>{"Master"}</MenuItem>
                  <MenuItem value={"Baby"} emed_tid={`${emedTid}_option_baby`}>{"Baby"}</MenuItem>
                  <MenuItem value={"Baby of"} emed_tid={`${emedTid}_option_baby_of`}>{"Baby of"}</MenuItem>
                  <MenuItem value={"Child"} emed_tid={`${emedTid}_option_child`}>{"Child"}</MenuItem>
                </Select>
              </FormControl>
              : data.label == "Gender" ?
                <FormControl size='small' sx={{ width: '10vw' }} emed_tid={`${emedTid}_form_control`}>
                  <InputLabel id="gender-select-label" emed_tid={`${emedTid}_label`}>{"Gender *"}</InputLabel>
                  <Select
                    sx={{ width: '10vw' }}
                    disabled={AbhaDisable || false}
                    labelId='gender-select-label'
                    size='small'
                    label={t(data.label)}
                    value={states[data.field_name]}
                    emed_tid={`${emedTid}_select`}
                    onChange={(e) => {
                      states[data.field_name] = e.target.value
                      this.setState({
                        states
                      })
                    }}
                  >
                    <MenuItem key={1} value={"m"} emed_tid={`${emedTid}_option_male`}>{t("Male")}</MenuItem>
                    <MenuItem key={2} value={"f"} emed_tid={`${emedTid}_option_female`}>{t("Female")}</MenuItem>
                    <MenuItem key={2} value={"t"} emed_tid={`${emedTid}_option_trans`}>{t("TransGender")}</MenuItem>
                  </Select>
                </FormControl>
                : data.label == "Patient Type" ?
                <FormControl size='small' sx={{ width: '10vw' }}>
                  <InputLabel id="gender-select-label">{"Patient Type"}</InputLabel>
                  <Select
                    sx={{ width: '10vw' }}
                    labelId='patient-type-select-label'
                    size='small'
                    label={t(data.label)}
                    value={states[data?.field_name]}
                    onChange={(e) => {
                      states[data?.field_name] = e.target.value
                      this.setState({
                        states
                      })
                    }}
                  >
                    <MenuItem key={1} disabled={states?.SelectedPatientType === "old_patient" || states?.SelectedPatientType === "review_patient"} value={"new_patient"}>{t("New Patient")}</MenuItem>
                    <MenuItem key={2} disabled={states?.SelectedPatientType === "old_patient"} value={"review_patient"}>{t("Review Patient")}</MenuItem>
                    <MenuItem key={3} value={"old_patient"}>{t("Old Patient")}</MenuItem>
                  </Select>
                </FormControl>
                : data.label === "City" ?
                  <Autocomplete
                    sx={{ width: "12vw" }}
                    size="small"
                    options={states.cityName ? states.cityName : []}
                    getOptionLabel={(option) => typeof (option) === "string" ? option : option.name}
                    onChange={(e, value) => {
                      this.setState({
                        city: value?.name ? value?.name : '',
                        // pin_code: '',
                      })
                    }}
                    clearIcon={false}
                    value={states.city}
                    renderInput={(params) => (
                      <TextField
                        label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                        InputProps={{ ...params.InputProps }}
                        onChange={(e) => this.setState({
                          city: e.target.value,
                          // pin_code: ''
                        })}
                        {...params}
                      />)}
                    onKeyDown={(e) => e.key === "Enter" ? e.preventDefault() : null}
                  />
                  : data.label === "Insurance Company Name" ?
                    <Autocomplete
                      sx={{ width: "12vw" }}
                      size="small"
                      options={states.InsuranceList}
                      getOptionLabel={(option) => (typeof (option) === "string" ? option : option.insurance_name)}
                      onChange={(event, value) => {
                        states["insurance_company_name"] = value?.insurance_name ? value?.insurance_name : ""
                        states["NewInsurance"] = false
                        this.setState({
                          states
                        })
                      }}
                      clearIcon={false}
                      value={states.insurance_company_name}
                      renderInput={(params) => (
                        <TextField
                          label={t("Insurance Company Name")} InputProps={{ ...params.InputProps }}
                          // onChange={(event) => {
                          //   states["insurance_company_name"] = event.target.value
                          //   states["NewInsurance"] = true
                          //   this.setState({
                          //     states
                          //   })
                          // }}
                          {...params}
                        />
                      )}
                    />
                    : data.label == "Mobile no" ?
                      <TextField
                        disabled={Object.keys(this.state.RequestedPatientData).length > 0}
                        label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                        autoComplete="off"
                        size="small"
                        onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                        InputProps={{
                          startAdornment: <InputAdornment position="start" emed_tid={`${emedTid}_adornment`}>{"+91"}</InputAdornment>
                        }}
                        value={states[data.field_name]}
                        emed_tid={`${emedTid}_input`}
                        onChange={(e) => {
                          var states = this.state
                          var isMobile = this.numberValidation(e.target.value)
                          if (data.label == "Mobile no") {
                            let mobileNum = e.target.value
                            if ((isMobile && mobileNum.length < 11) || e.target.value == "") {
                              states[data.field_name] = e.target.value
                              if (e.target.value.length === 10) { this.CheckExistingPatients() }
                            }
                          }
                          this.setState({ states })
                        }}
                        error={states.mobile_no !== "" && states.mobile_no.length !== 10}
                      />
                      : data.label == "Corporate Name" ?
                        <FormControl size='small' sx={{ width: '12vw' }}>
                          <InputLabel id="gender-select-label">{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                          <Select
                            sx={{ width: '12vw' }}
                            MenuProps={{ style: { maxHeight: 250 } }}
                            labelId='gender-select-label'
                            size='small'
                            label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                            value={states[data.field_name]}
                            onChange={(e) => {
                              states[data.field_name] = e.target.value
                              if (e.target.value === "") { states.employee_id = "" }
                              this.setState({
                                states
                              })
                            }}
                          >
                            <MenuItem value={""}>{"None"}</MenuItem>
                            {
                              states.CorporateList.length > 0 ?
                                states.CorporateList.map((list, index) => (
                                  <MenuItem key={index} value={list.id}>{list.company_name}</MenuItem>
                                )) : null
                            }
                          </Select>
                        </FormControl>
                        : data.label == "Marital Status" ?
                          <FormControl size='small' sx={{ width: '12vw' }}>
                            <InputLabel id="gender-select-label">{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                            <Select
                              sx={{ width: '12vw' }}
                              labelId='gender-select-label'
                              size='small'
                              label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                              value={states[data.field_name]}
                              onChange={(e) => {
                                states[data.field_name] = e.target.value
                                states["manuallyChanged"] = false
                                this.setState({
                                  states
                                })
                              }}
                            >
                              <MenuItem key={1} value={"Single"}>{t("Single")}</MenuItem>
                              <MenuItem key={2} value={"Married"}>{t("Married")}</MenuItem>
                              <MenuItem key={2} value={"Divorced"}>{t("Divorced")}</MenuItem>
                            </Select>
                          </FormControl>
                          : data.label == "Employee ID No" ?
                            <TextField
                              autoComplete="off"
                              inputProps={{ maxLength: 20 }}
                              label={(type === 'mandatory' || data.is_default || states.employer_id) ? (t(data.label) + "*") : t(data.label)}
                              size="small" value={states[data.field_name]}
                              onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                              onChange={(e) => {
                                states[data.field_name] = e.target.value.toUpperCase()
                                this.setState({ states })
                              }}
                              disabled={states.employer_id === null || states.employer_id === ""}
                            />
                            : data.label == "State" ?
                              // <RegionDropdown className='eMed_demo_dropdown_inputs'
                              //   country={this.state.country}
                              //   value={this.state.state}
                              //   onChange={(val) => {
                              //     states[data.field_name] = val
                              //     this.setState({ states })
                              //   }} />
                              <FormControl size='small' sx={{ width: '12vw' }}>
                                <InputLabel id="title-select-label">{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                                <Select
                                  sx={{ width: '12vw' }}
                                  MenuProps={{ style: { maxHeight: 250, maxWidth: '12vw' } }}
                                  labelId='gender-select-label'
                                  size='small'
                                  label={data.label}
                                  value={states.state_code}
                                  onChange={(e) => {
                                    this.setState({ state_code: e.target.value },
                                      () => {
                                        this.setState({ cityName: City.getCitiesOfState(this.state.country_code, this.state.state_code), city: ''})
                                      })
                                  }}
                                >
                                  {
                                    states.AllStates.map((list) => (
                                      <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                                    ))
                                  }
                                </Select>
                              </FormControl>
                              : data.label == "Country" ?
                                <FormControl size='small' sx={{ width: '12vw', maxWidth: '12vw' }}>
                                  <InputLabel id="title-select-label">{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                                  <Select
                                    sx={{ width: '12vw' }}
                                    MenuProps={{ style: { maxHeight: 250, maxWidth: '12vw' } }}
                                    labelId='gender-select-label'
                                    label={data.label}
                                    size='small'
                                    value={states.country_code}
                                    onChange={(e) => {
                                      this.setState({ country_code: e.target.value, state_code: "", city: '' }, () => {
                                        this.setState({ AllStates: State.getStatesOfCountry(this.state.country_code), cityName: '' })
                                      })
                                    }}
                                  >
                                    {
                                      states.AllCountry.map((list) => (
                                        <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                                      ))
                                    }
                                  </Select>
                                </FormControl>
                                // <CountryDropdown className='eMed_demo_dropdown_inputs'
                                //   value={this.state.country}
                                //   onChange={(val) => this.setState({ country: val })}
                                //   priorityOptions={["IN"]}
                                //   whitelist={["IN", "AF", "AU", "BT", "CA", "CU", "FR", "DE", "ID", "IR", "JP", "KZ", "MY", "MV", "MN", "PK", "RU", "SA", "SG", "LK", "TW", "TH", "TR", "AE", "GB", "US"]}
                                // />
                                : data.label === "Father/Spouse Name" ?
                                <Box component={'div'} display={'flex'}>
                                  <Select
                                    size='small'
                                    value={this.state.selectedFatHusName}
                                    onChange={(e) => this.setState({ selectedFatHusName: e.target.value })}
                                    sx={{width:'3.5vw'}}
                                  >
                                    <MenuItem value={1}>Father</MenuItem>
                                    <MenuItem value={2}>Spouse</MenuItem>
                                  </Select>
                                  <TextField
                                    label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                                    autoComplete="off"
                                    size="small"
                                    inputProps={{maxLength:32}}
                                    onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                                    value={states[data.field_name]}
                                    onChange={(e) => {
                                      let states = this.state
                                      let isSpecial = /^[ A-Za-z.,/]*$/.test(e.target.value)
                                      if (isSpecial || e.target.value == "") {
                                        states[data.field_name] = e.target.value
                                        this.setState({states })
                                      }
                                    }}
                                    sx={{width:'10vw'}}
                                  />
                                    </Box> :
                                    data.label === "RCH ID" ?
                                      <TextField
                                        size="small"
                                        label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                                        inputProps={{
                                          maxLength: 13,
                                          pattern: "^[0-9-]*$",
                                        }}
                                        value={this.state.rchid || ""}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          const numericHyphenOnly = /^[0-9-]*$/.test(value);
                                          let rchError = false;

                                          if (!numericHyphenOnly) return;

                                          const digitsOnly = value.replace(/-/g, "");
                                          const hyphenCount = (value.match(/-/g) || []).length;

                                          if (hyphenCount > 1) return;

                                          if (digitsOnly.length > 12) return;

                                          if (value !== "") {
                                            rchError = digitsOnly.length !== 12;
                                          }

                                          this.setState({
                                            rchid: value,
                                            rchError,
                                          });
                                        }}
                                        error={this.state.rchError}
                                      // helperText={
                                      //   this.state.rchError
                                      //     ? "Invalid RCH ID. Must have exactly 12 digits and only one hyphen allowed"
                                      //     : ""
                                      // }
                                      // sx={{ width: "12vw", marginTop: "2.5vh", marginLeft: "1vw" }}
                                      />
                                      :
                                  data.label == "Blood Group" ?
                                    <Autocomplete
                                      clearIcon
                                      size='small'
                                      sx={{ width: '12vw' }}
                                      options={this.state.medicalBloodGroup?.map((item) => item.label)}
                                      value={states[data.field_name]}
                                      autoComplete='off'
                                      onChange={(event, newValue) => {
                                        states[data.field_name] = newValue
                                        this.setState({ states })
                                      }}
                                      renderInput={(params) => <TextField {...params} label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)} />}
                                    />
                                    :
                                <TextField
                                  disabled={((data.label === "First Name") ? (Object.keys(this.state.RequestedPatientData)?.length > 0 || AbhaDisable) : false) || ((data.label === "CCN Number" || data.label === "Insurance No") ? !states?.insurance_company_name : false) || ((data.label === "Middle Name" || data.label === "Surname" || data.label === "Age") ? ( AbhaDisable) : false)}
                                  autoComplete="off"
                                  inputProps={{ maxLength: (data.label === "First Name" || data.label === "Middle Name" || data.label === "Surname" || data.label === "Referred By" || data.label === "Referral Source" || data.label === "Mother's Name" || data.label === "Father/Spouse Name" || data.label === "Emergency Contact Person" || data.label === "Relationship") ? 32 : ( data.label === "Occupation" || data.label === "'Insurance Company Name'" || data.label === "Insurance No") ? 45 : ( data.label === "Email ID") ? 50 : 100 }}
                                  label={(type === 'mandatory' || data.is_default || (states?.insurance_company_name && data.label === "Insurance No")) ? (t(data.label) + "*") : t(data.label)}
                                  variant="outlined"
                                  value={states[data.field_name]}
                                  onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                                  emed_tid={`${emedTid}_input`}
                                  onChange={(e) => {
                                    var isAlpha = this.alphaValidation(e.target.value)
                                    var isNum = this.numberValidation(e.target.value)
                                    var isAlphaNum = CommonValidation.alphanumValidation(e.target.value)
                                    let isSpecial = /^[ A-Za-z.,/]*$/.test(e.target.value)

                                    if (data.label === "Age" || data.label === "Father/Spouse Age" || data.label === "Mother's Age") {
                                      var age = e.target.value
                                      if ((isNum && +(age) <= 150 && +age !== 0) || e.target.value == "") {
                                        states[data.field_name] = e.target.value
                                        states['dob'] = data.label === "Age" ? null : states.dob
                                        this.setState({
                                          states,
                                        }, () => {
                                          if (data.label === "Age") {
                                            var approxDob = this.handleFindApproxDob(this.state.age);
                                            this.setState({
                                              dob: approxDob
                                            })
                                          }
                                        })
                                      }
                                      else if (e.target.value.includes("/")) {
                                        this.setState({ age: "", dob: null })
                                      }
                                    }
                                    else if (data.label === "First Name" || data.label === "Middle Name" || data.label === "Surname" || data.label === "Emergency Contact Person" || data.label === "Occupation" || data.label === "Relationship" || data.label === "City" || data.label === "Guardian") {
                                      if (isAlpha || e.target.value == "") {
                                        states[data.field_name] = e.target.value
                                        this.setState({
                                          states
                                        })
                                      }
                                    }
                                    else if (data.label === "Father/Spouse Name" || data.label === "Mother's Name") {
                                      if (isSpecial || e.target.value == "") {
                                        states[data.field_name] = e.target.value
                                        this.setState({
                                          states
                                        })
                                      }
                                    }
                                    else if (data.label === "Pin Code") {
                                      if ((isNum || e.target.value == "") && e.target.value.length <= 6) {
                                        states[data.field_name] = e.target.value
                                        this.setState({
                                          states
                                        }, () => {
                                          if (this.state.pin_code && this.state.pin_code.length === 6) {
                                            this.getPincodeToCity(this.state.pin_code)
                                          }
                                        })
                                      }
                                    }
                                    else if (data.label === "Emergency Mobile No") {
                                      if ((isNum || e.target.value == "") && e.target.value.length <= 10) {
                                        states[data.field_name] = e.target.value
                                        this.setState({
                                          states
                                        })
                                      }
                                    }
                                    else if (data.label === "Insurance No") {
                                      if ((isAlphaNum || e.target.value == "")) {
                                        states[data.field_name] = e.target.value
                                        this.setState({
                                          states
                                        })
                                      }
                                    }
                                    else {
                                      states[data.field_name] = e.target.value
                                      this.setState({
                                        states
                                      })
                                    }
                                  }}
                                  size="small"
                                />
          }
        </Box>
      </form>
    )
  }
  getConnectedDevices = () => {
    navigator?.mediaDevices?.enumerateDevices()
      .then(devices => {
        const videoDevices = devices?.filter(device => device.kind === 'videoinput');
        this.setState({
          devices: videoDevices,
        });
      })
      .catch(error => {
        console.error('Error enumerating devices:', error);
      });
  }
  videoConstraints = () => ({
    facingMode: this.state.isFrontCamera ? 'user' : 'environment',
  });

  toggleCameraButton = () => {
    this.setState({
      isFrontCamera: !this.state.isFrontCamera,
      temp_patient_img: null
    }, () => { this.videoConstraints() })
  }


  OpenWebCamPopUP = () => {
    try {
      return (
        <Box>
          <Modal open={true}>
            <Box className="eMed_WebCamPop_Main">
              <Box component={'div'} className="eMed_WebCam_Header">
                <Typography variant='h6'>{"Patient Profile "}</Typography>
                <Button onClick={() => { this.setState({ temp_patient_img: this.state.patient_img, ProfilePicClicked: false }) }} >
                  <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                </Button>
              </Box>
              <Box component={'div'}>
                {
                  this.state.temp_patient_img === null ?
                    <Webcam
                      className='eMed_WebCam_Div'
                      audio={false}
                      mirrored={this.state.isFrontCamera}
                      ref={this.webcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={this.videoConstraints()}
                    /> :
                    <img className='eMed_WebCam_Img_Div' src={this.state.temp_patient_img} />
                }
              </Box>
              <Box component={'div'} className="eMed_WebCam_Btn_div" width={"70%"} mr={"3vw"} ml={"7vw"}>
                <Button disabled={this.state.temp_patient_img !== null} variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ temp_patient_img: this.webcamRef.current.getScreenshot() }) }} emed_tid="doc_demographics_profile_capture_btn">Capture</Button>
                <Button variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ temp_patient_img: null }) }} emed_tid="doc_demographics_profile_retake_btn">Retake</Button>
                <Button disabled={this.state.temp_patient_img === null} variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ patient_img: this.state.temp_patient_img, ProfilePicClicked: false }) }} emed_tid="doc_demographics_profile_set_btn">Set Profile</Button>
                {this.state.devices?.length > 1 &&
                  <Button variant='contained' size='small' id="eMed_Config_btn" sx={{width: '10.5vw'}} onClick={() => { this.toggleCameraButton() }} emed_tid="doc_demographics_profile_toggle_camera_btn">
                    Switch to {this.state.isFrontCamera ? "Back" : "Front"} Camera
                  </Button>}
              </Box>
            </Box>
          </Modal>
        </Box>
      );
    } catch (e) { }
  };


  renderCreateAppointmentLeft = () => {
    const { t, fromViewGraphics } = this.props
    const fileExtension =( (this.state.duplicatedDocDocument?.includes(".jpg")) || (this.state.duplicatedDocDocument?.includes(".jpeg")) || (this.state.duplicatedDocDocument?.includes(".png"))) ? true : false

    var states = this.state
    var Mandatory_Array = []
    var Non_Mandatory_Array = []
    const SplitCount = +(states.mandotory_count)
    const Total_Len = (states.layoutData).length
    let fromDemographic = getCachevalue('updatePatient')

    var Active_Array = (states.layoutData).filter((item) => {
      return item.is_active == true
    })

    Mandatory_Array = (Active_Array).slice(0, SplitCount)
    Non_Mandatory_Array = (Active_Array).slice(SplitCount, Total_Len)

    if (fromDemographic && this.state.SelectedPatientID && this.state.PatientTypeConfig) {
      const newData = { label: 'Patient Type', field_name: 'patient_type', id: Total_Len + 1, is_active: true, is_default: false };
      Non_Mandatory_Array = [...Non_Mandatory_Array, newData];
    }
    const userData = JSON.parse(localGetItem("loggedInUserInfo"))
    return (
      <Box component={"div"} className={fromViewGraphics ? "eMed_createapt_left eMed_ipcreateapt_left" : "eMed_createapt_left"} emed_tid="doc_demographics_left_container">
        <Box className="eMed_createapt_left1" emed_tid="doc_demographics_left_section1">
          <Paper className='eMed_createapt_left1_paper1' emed_tid="doc_demographics_referral_paper">
            <Typography className='eMed_refdoc_title' emed_tid="doc_demographics_referral_title">{t("Referral Information")}</Typography>
            <Box component={'div'} className="eMed_createapt_left1_paper1_box" emed_tid="doc_demographics_referral_box">
              <FormControl size='small' sx={{ width: '15vw' }} emed_tid="doc_demographics_referred_by_form">
                <InputLabel id="referredby-select-label" emed_tid="doc_demographics_referred_by_label">{"Referred By"}</InputLabel>
                <Select
                  labelId="referredby-select-label"
                  MenuProps={{ style: { maxHeight: 250 } }}
                  size='small'
                  value={states.referredBy}
                  label={"Referred By"}
                  emed_tid="doc_demographics_referred_by_select"
                  onChange={(e) => {
                    this.setState({
                      referredBy: e.target.value
                    })
                  }}
                >
                  <MenuItem value={""} emed_tid="doc_demographics_referred_by_option_empty">{"Select Doctor"}</MenuItem>
                  {states.refDoctorData.map((item, index) => (
                    <MenuItem key={index} value={item.name} emed_tid={`doc_demographics_referred_by_option_${index}`}>{item.name}</MenuItem>
                  ))}

                </Select>
              </FormControl>
              <FormControl size='small' sx={{ width: '15vw' }} emed_tid="doc_demographics_referral_source_form">
                <InputLabel id="referralSrc-select-label" emed_tid="doc_demographics_referral_source_label">{"Referral Source"}</InputLabel>
                <Select
                  labelId="referralSrc-select-label"
                  MenuProps={{ style: { maxHeight: 250 } }}
                  size='small'
                  value={states.referralSource}
                  label={"Referral Source"}
                  emed_tid="doc_demographics_referral_source_select"
                  onChange={(e) => {
                    this.setState({
                      referralSource: e.target.value
                    })
                  }}
                >
                  <MenuItem value={""} emed_tid="doc_demographics_referral_source_option_empty">{"Select Source"}</MenuItem>
                  {states.refSourceData.map((item, index) => (
                    <MenuItem key={index} value={item.source_name} emed_tid={`doc_demographics_referral_source_option_${index}`}>{item.source_name}</MenuItem>
                  ))}

                </Select>
              </FormControl>
              <input
                type="file"
                accept="application/pdf, image/jpg, image/jpeg, image/png"
                onChange={(e) => this.UploadImage(e, "docDocument")}
                ref={this.uploadImage}
                style={{ display: "none" }}
                emed_tid="doc_demographics_document_input"
              />
              {
                (this.state.docDocument === null || this.state.docDocument === "delete") ?
                  <Button
                    size='small'
                    variant="contained"
                    endIcon={
                      <FileUploadOutlinedIcon emed_tid="doc_demographics_upload_icon" />
                    }
                    onClick={() => this.uploadImage.current.click()}
                    emed_tid="doc_demographics_upload_document_btn"
                  >
                    Upload Document
                  </Button>
                  :
                  <Box emed_tid="doc_demographics_document_preview_box">
                    <div className='emedhub_doc_image_size' emed_tid="doc_demographics_document_preview_container">
                      <Tooltip title={typeof (this.state.docDocument) === "string" ? null : this.state.docDocument?.name} arrow placement='top' emed_tid="doc_demographics_document_tooltip">
                        <img
                          onClick={() => {
                            if (typeof this.state.docDocument === "string") {
                              if (fileExtension || this.state.docDocument && ((typeof (this.state.docDocument) !== "object") && (typeof (this.state.docDocument) !== "string")) && this.state.docDocument?.startsWith("blob:")) {
                                this.setState({ SelectedDocSRC: this.state.docDocument })
                              } else if (typeof this.state.docDocument === "string" && this.state.duplicatedDocDocument?.includes(".pdf")) {
                                this.fetchAndConvertToBase64(this.state.docDocument)?.then((base64) => {
                                  base64 = base64?.replace("data:binary/octet-stream;", "data:application/pdf;");
                                  this.setState({ pdfPreview: true, pdfData: base64 })
                                });
                              }
                            }
                          }}
                          src={this.state.docDocument && typeof (this.state.docDocument) !== "object" && (this.state.docDocument?.startsWith("blob:") && fileExtension) ? this.state.docDocument : ImagePaths.DocumentPreview.default}
                          className='eMed_createapt_right2_field_img_inv'
                          emed_tid="doc_demographics_document_img"
                        />
                      </Tooltip>
                      <div emed_tid="doc_demographics_document_delete_container">
                        <IconButton onClick={() => {
                          this.state.docDocument = "delete"
                          this.setState({ states })
                        }}
                          size='small'
                          className='emedhub_icon_img_close'
                          emed_tid="doc_demographics_document_delete_btn"
                        ><Close fontSize='small' /></IconButton>
                      </div>
                    </div>
                    {/* <div className='emedhub_doc_image_size'>
                      <img onClick={() => { this.setState({ SelectedDocSRC: this.state.docDocument, refDocumentSelected: true }) }} src={typeof (this.state.docDocument) === "string" ? this.state.docDocument : this.state.docDocument?.type === "application/pdf" ? ImagePaths.Reports.default : this.state.docDocument?.data_url} className='eMed_createapt_right2_field_img_inv' />
                      <div>
                        <IconButton onClick={() => {
                          this.setState({ docDocument: "delete" })
                        }} emed_tid={`doc_demographics_doc_delete_btn_${index}`}
                          size='small'
                          className='emedhub_icon_img_close'
                        ><Close fontSize='small' /></IconButton>
                      </div>
                    </div> */}
                  </Box>
              }
            </Box>
          </Paper>
          <Paper className='eMed_createapt_left1_paper2' emed_tid="doc_demographics_profile_paper">
            <IconButton className='eMed_createapt_left1_paper2_icon' onClick={() => { this.setState({ ProfilePicClicked: true },()=>{ this.getConnectedDevices()}) }} emed_tid="doc_demographics_profile_btn">
              <img className='eMed_createapt_left1_paper2_img' src={this.state.patient_img === null ? ImagePaths.UploadPatientDP.default : this.state.patient_img} alt="ProfileImage" emed_tid="doc_demographics_profile_img" />
            </IconButton>
          </Paper>
        </Box>
        <Paper className={fromViewGraphics ? 'eMed_createapt_left2 eMed_ipcreateapt_left2' : 'eMed_createapt_left2'} emed_tid="doc_demographics_patient_info_paper">
          <Box className='eMed_refdoc_title eMed_Demo_Title' emed_tid="doc_demographics_patient_info_header">
            <Typography sx={{ fontWeight: 600 }} emed_tid="doc_demographics_patient_info_title">{t("Patient Information")}</Typography>
            {this.state.appointmentId ?
              <Tooltip title={'Print OP Card'} emed_tid="doc_demographics_print_tooltip">
                <img style={{ marginLeft: '0.6vw', width: '1.3vw', height: '1.3vw', cursor: 'pointer' }}
                  src={ImagePaths.PrintIcons.default} alt='' onClick={() => { this.printOPCard() }} emed_tid="doc_demographics_print_icon" />
              </Tooltip> : null}
            <Box sx={{ width: '18.5vw' }} emed_tid="doc_demographics_patient_info_meta">
              <Box className='eMed_OP_PatientType' emed_tid="doc_demographics_created_by_container">
                <Box className='eMed_Demo_Created_Con' emed_tid="doc_demographics_created_by_label_box">
                  <Typography id='eMed_Demo_Created_Text' emed_tid="doc_demographics_created_by_label">{t('CreatedBy')}</Typography>
                  <Typography id='eMed_Demo_Created_Text' emed_tid="doc_demographics_created_by_colon">:</Typography>
                </Box>
                <Typography id='eMed_Demo_Created_Text' emed_tid="doc_demographics_created_by_value">{this.state.createdBy ? this.state.createdBy : '-'}</Typography>
              </Box>
              <Box className='eMed_OP_PatientType' emed_tid="doc_demographics_modified_by_container">
                <Box className='eMed_Demo_Created_Con' emed_tid="doc_demographics_modified_by_label_box">
                  <Typography id='eMed_Demo_Created_Text' emed_tid="doc_demographics_modified_by_label">{t('ModifiedBy')}</Typography>
                  <Typography id='eMed_Demo_Created_Text' emed_tid="doc_demographics_modified_by_colon">:</Typography>
                </Box>
                <Typography id='eMed_Demo_Created_Text' emed_tid="doc_demographics_modified_by_value">{this.state.modifiedBy ? this.state.modifiedBy : '-'}</Typography>
              </Box>
            </Box>
          </Box>


          <Box className="eMed_demolayout_left_TextInput" emed_tid="doc_demographics_mandatory_fields">
            {Mandatory_Array.map((item, index) => (
              this.renderInput(item, 'mandatory')
            ))}
          </Box>
          <Divider emed_tid="doc_demographics_fields_divider" />
          <Box className="eMed_demolayout_left_TextInput" emed_tid="doc_demographics_non_mandatory_fields">
            {Non_Mandatory_Array.map((item, index) => (
              this.renderInput(item, 'non-mandatory')
            ))}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', paddingLeft: '2vw', paddingTop: '0.3vw'}} emed_tid="doc_demographics_communication_preferences">
            {/* <FormControlLabel control={<Checkbox checked={this.state.receive_email} onChange={(e) => { this.setState({ receive_email: e.target.checked }) }} size='small' />} label="Receive Email" /> */}
            <FormControlLabel control={<Checkbox checked={this.state.receive_sms} onChange={(e) => { this.setState({ receive_sms: e.target.checked }) }} size='small' emed_tid="doc_demographics_receive_sms_checkbox" />} label="Receive SMS" emed_tid="doc_demographics_receive_sms_label" />
            {userData?.whatsapp_configuration ? <FormControlLabel control={<Checkbox checked={this.state.receive_whatsapp} onChange={(e) => { this.setState({ receive_whatsapp: e.target.checked }) }} size='small' emed_tid="doc_demographics_receive_whatsapp_checkbox" />} label="WhatsApp" emed_tid="doc_demographics_receive_whatsapp_label" /> : null}
          </Box>
        </Paper>

      </Box>
    )
  }


  renderDropdown = (label, mt, Data = [], stateKey) => {
    var states = this.state
    const labelTid = label.replace(/\s+/g, '_').toLowerCase();
    return (
      <Box sx={{ width: label === "Optometrist" ? "92%" : '45%', mt: mt }} emed_tid={`doc_demographics_${labelTid}_box`}>
        <Autocomplete
          size='small'
          clearIcon={false}
          sx={{ width: label === "Optometrist" ? '27.5vw' : '14vw' }}
          componentsProps={{ popper: { style: { width: label === 'Doctor' ? "23vw" : label === "Optometrist" ? "23vw" : "14vw" } } }}
          disabled={this.props?.is_Nurse && label === "Specialization" ? true : false}
          options={Data}
          getOptionLabel={(item) => ((label === "Doctor" ? item.doctor_name : label === "Specialization" ? item.name : label === "Patient Tag" ? item.patient_tag_name : label === "Appointment Type" ? item.appoinment_type : label === "Nurse" ? item.nurse : label === "Optometrist" ? item.name  : ""))}
          value={states[stateKey]}
          emed_tid={`doc_demographics_${labelTid}_autocomplete`}
          renderOption={label === 'Doctor' ? (props, item) => (
            <Box>
              {props["data-option-index"] === 0 ?
                <Box className="eMed_App_Doctor_table_head">
                  <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>Doctor Name</Typography>
                  <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Total App</Typography>
                  <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>New App</Typography>
                </Box> : null}
              <Box component="li" className='eMed_App_Doctor_table_data' {...props}>
                <div style={{ width: "50%" }}>{item?.doctor_name.length > 15 ? <Tooltip placement="top" title={item?.doctor_name} arrow><div>{item?.doctor_name.slice(0, 16) + "..."}</div></Tooltip> : item?.doctor_name ? item?.doctor_name : "-"}</div>
                <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.total_appointment}</Typography>
                <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.new_appointment}</Typography>
              </Box>
            </Box>) :
            label === 'Optometrist' ? (props, item) => (
              <Box>
                {props["data-option-index"] === 0 ?
                  <Box className="eMed_App_Doctor_table_head" sx={{ width: "22vw" }}>
                    <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>Optometrist Name</Typography>
                    <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Total App</Typography>
                    <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Pending App</Typography>
                  </Box> : null}
                <Box component="li" className='eMed_App_Doctor_table_data' {...props} sx={{ width: '22vw' }}>
                  <div style={{ width: "50%" }}>{item?.name?.length > 15 ? <Tooltip placement="top" title={item?.name} arrow><div>{item?.name.slice(0, 16) + "..."}</div></Tooltip> : item?.name ? item?.name : "-"}</div>
                  <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.total_appointment_count}</Typography>
                  <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.pending_appointment_count}</Typography>
                </Box>
              </Box>
            ) : null}
          onChange={(event, newValue) => {
            states[stateKey] = newValue
            if (newValue !== null && "doctor_id" in newValue && label !== "Optometrist") {
              let docDetail = { ...newValue }
              docDetail["name"] = docDetail["specialization_name"];
              delete docDetail.specialization_name;
              docDetail["id"] = docDetail["specialization_id"];
              delete docDetail.specialization_id;
              states["selectedSpecId"] = docDetail;
            }
            if (newValue !== null && "name" in newValue && label !== "Optometrist") {
              let filteredLst = states["doctorList"].length > 0 && states["doctorList"].filter(item => item["specialization_id"] === newValue["id"])
              states["filteredDocList"] = filteredLst.length > 0 && filteredLst;
              states["selectedDocId"] = null;
            }
            if (newValue === null && label === "Specialization") {
              states["filteredDocList"] = states["doctorList"];
            }
            if(label === "Specialization"){
              states['selectedOptometrist'] = null
            }
            this.setState({ states })
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label + `${(label === "Doctor" || label === "Specialization" || label === "Nurse" || label === "Optometrist") ? " *" : ""}`}
              placeholder={label}
              emed_tid={`doc_demographics_${labelTid}_input`}
            />
          )}
        />
      </Box>
    )
  }

  UploadImage = (e, key, imgKey) => {
    let states = this.state
    states[key] = e.target.files[0]
    states[imgKey] = null
    states[imgKey + "Cap"] = null
    this.setState({ states })
    e.target.value = ''
  }


  renderIdentityProof = (Label, key, NumberKey, duplicatedata, imgKey) => {
    const fileExtension =( (duplicatedata?.includes(".jpg")) || (duplicatedata?.includes(".jpeg")) || (duplicatedata?.includes(".png"))) ? true : false

    let states = this.state;
    const btnDisable = (states[imgKey + "Cap"] || states[key]) && states[key] !== "delete";
    const labelTid = Label.toLowerCase();
    return (
      <Box className="eMed_createapt_right2_box" emed_tid={`doc_demographics_${labelTid}_proof_box`}>
        <TextField
          label={Label}
          sx={{ flex: "0 0 18vw" }}
          size="small"
          value={states[NumberKey]}
          emed_tid={`doc_demographics_${labelTid}_proof_input`}
          onChange={(e) => {
            let value = e.target.value
            if (NumberKey === "aadhar_card_number") {
              let Valid = CommonValidation.numberOnly(value)
              if ((Valid || value === "") && value.length <= 12) {
                states[NumberKey] = value
              }
            }
            else if (NumberKey === "passport_number") {
              let Valid = CommonValidation.ALPHA_NUMARIC(value)
              if ((Valid || value === "") && value.length <= 8) {
                states[NumberKey] = value.toUpperCase()
              }
            }
            else {
              let Valid = CommonValidation.ALPHA_NUMARIC(value)
              if ((Valid || value === "") && value.length <= 15) {
                states[NumberKey] = value.toUpperCase()
              }
            }
            this.setState({ states })
          }}
        />
        <Box sx={{display: "flex", alignItems: "center", flex: 0.3, gap: "0.1vw"}} emed_tid={`doc_demographics_${labelTid}_proof_actions`}>
        <IconButton size='small' component="label" disabled = {btnDisable} emed_tid={`doc_demographics_${labelTid}_proof_upload_btn`}>
          <input onChange={(e) => this.UploadImage(e, key, imgKey)} hidden accept="application/pdf, image/jpg, image/jpeg, image/png" type="file" emed_tid={`doc_demographics_${labelTid}_proof_file_input`} />
          <img className='eMed_createapt_right2_field_img' src={btnDisable ? ImagePaths.UploadBtnThemeOff.default : ImagePaths.UploadBtnTheme.default} alt="" emed_tid={`doc_demographics_${labelTid}_proof_upload_icon`} />
        </IconButton>
        <IconButton size='small' component="label" disabled = {btnDisable} onClick={() => { this.setState({ imgCapClked: true, slcIdKey: imgKey },()=>{ this.getConnectedDevices()}) }} emed_tid={`doc_demographics_${labelTid}_proof_capture_btn`}>
          <img className='eMed_createapt_right2_field_img' src={btnDisable ? ImagePaths.captureImgOff.default : ImagePaths.captureImg.default} alt="" emed_tid={`doc_demographics_${labelTid}_proof_capture_icon`} />
        </IconButton>
        {(states[key] !== null && states[key] !== "delete") ?
          <div className='emedhub_doc_image_size'>
            <Tooltip title={typeof (states[key]) === "string" ? null : states[key]?.name} arrow placement='top'>
              <img
                onClick={() => {
                  if (typeof (states[key]) === "string") {
                    if (fileExtension || states[key] && ((typeof (states[key]) !== "object") && (typeof (states[key]) !== "string")) && states[key]?.startsWith("blob:")) {
                      this.setState({ SelectedDocSRC: states[key] })
                    } else if (typeof states[key] === "string" && duplicatedata?.includes(".pdf")) {
                      this.fetchAndConvertToBase64(states[key])?.then((base64) => {
                        base64 = base64?.replace("data:binary/octet-stream;", "data:application/pdf;");
                        this.setState({ pdfPreview: true, pdfData: base64 })
                      });
                    }
                  }
                }}
                src={states[key] && typeof (states[key]) !== "object" && (states[key]?.startsWith("blob:") && fileExtension) ? states[key] : ImagePaths.DocumentPreview.default}

                className='eMed_createapt_right2_field_img_inv' />
            </Tooltip>
            <div>
              <IconButton onClick={() => {
                states[key] = "delete"
                this.setState({ states })
              }}
                size='small'
                className='emedhub_icon_img_close'
              ><Close fontSize='small' /></IconButton>
            </div>
          </div> 
            : (states[imgKey + "Cap"] !== null) ?
              <div className='emedhub_doc_image_size'>
                <img src={ImagePaths.ImagePreview.default} className='eMed_createapt_right2_field_img_inv' />
                <IconButton
                  onClick={() => {
                    this.setState({ [imgKey + "Cap"]: null, [imgKey]: null })
                  }}
                  sx={{ marginRight: 0 }}
                  size='small'
                  className='emedhub_icon_img_close'
                ><Close fontSize='small' /></IconButton>
              </div>
              : null}
        </Box>
      </Box>
    )
  }

  convertTo12Hour(time) {
    const [hour, minute] = time.split(':').map(Number);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12; // Converts "0" hour to "12"
    return `${hour12}:${minute.toString().padStart(2, '0')} ${ampm}`;
  }

  ClosePopUp = () => {
    this.setState({ pdfPreview: false, pdfData: '' })
  }

  getSlotIntervel = () => {
    var date = new Date(this.state.appointmentDateTime)
    var appointment_date = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
    let userData = JSON.parse(localGetItem("loggedInUserInfo"))
    let clinicId = getCachevalue('SelectedDoctorClinic')
    let DOctorId = userData?.doctor_id ? userData?.doctor_id : null
    this.LoaderFunction(true)
    try {
      RestAPIService.getAll(Serviceurls.SCHEDULE_TIME_GET + "?date=" + appointment_date + "&doctor_id=" + DOctorId + "&clinic_id=" + clinicId)
        .then((response) => {
          if (response.data.status === "success") {
            this.setState({
              slotList: this.state.selectedAppointTypeId?.appoinment_type === "Tele Consultation" ?  response.data.data?.tele : (response.data.data?.normal || []),
              slotPopup: true
            }, () => { this.LoaderFunction(false) })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
          this.LoaderFunction(false)
        })

    } catch (e) {
      this.errorMessage(e.message)
      this.LoaderFunction(false)
    }
  }

  renderDateTimeFilter = () => {
    try {
      let today = new Date()
      let maxDate = new Date()
      if (this.state.dateLimitType === "Days") {
        maxDate.setDate(today.getDate() + this.state.dateLimit)
      } else {
        maxDate.setMonth(today.getMonth() + this.state.dateLimit);
      }
      let formatMaxDate = maxDate.toISOString()?.slice(0, 10)

      return (
        <Box sx={{ mt: '1vw' }} emed_tid="doc_demographics_appointment_datetime_box">
          <LocalizationProvider dateAdapter={AdapterDateFns} emed_tid="doc_demographics_appointment_datetime_provider">
            <DateTimePicker
              open={this.state.DateOpen}
              onOpen={() => { this.setState({ DateOpen: true }) }}
              onClose={() => { this.setState({ DateOpen: false }) }}
              inputFormat='dd-MM-yyyy & hh:mm a'
              value={this.state.appointmentDateTime}
              minDate={new Date((new Date).getFullYear(), (new Date).getMonth() - 2, 1)}
              // maxDate={new Date((new Date).getFullYear(), (new Date).getMonth() + 3, 0)}
              maxDate={formatMaxDate}
              emed_tid="doc_demographics_appointment_datetime_picker"
              onChange={(newDate) => {
                if (newDate === null) {
                  this.setState({ appointmentDateTime: new Date() })
                }
                else {
                  this.setState({ appointmentDateTime: newDate })
                }
              }}
              renderInput={(params) => <TextField size='small'
                onKeyDown={(e) => e.preventDefault()}
                onClick={() => { this.setState({ DateOpen: true }) }}
                {...params}
                fullWidth
                variant='outlined'
                label="Appointment Date & Time *"
                style={{ width: "14vw", marginRight: "0.5vw", marginLeft: "0.5vw" }}
                emed_tid="doc_demographics_appointment_datetime_input"
              />}
            />
          </LocalizationProvider>
          <Button variant='outlined' disabled={!this.state.isQmsConfig} style={{ width: "14vw", height: "2.5vw" }} size="small" id="eMed_Config_btn" onClick={() => { this.getSlotIntervel() }} emed_tid="doc_demographics_select_slot_btn">{this.state.selectedSlot ? `Slot : ${this.convertTo12Hour(this.state.selectedSlot)}` : "Select Appointment Slots"}</Button>

        </Box>
      )
    } catch (e) {

    }
  }

  renderCreateAppointmentRight = () => {
    try {
      const { t } = this.props
      var states = this.state
      let patientCreate = this.props.history?.location?.state?.fromCreate
      const userData = JSON.parse(localGetItem("loggedInUserInfo"))
      return (
        <Stack component={'div'} emed_tid="doc_demographics_right_container">
          {
            (patientCreate) ?
              <Paper elevation={2} sx={{ height: (userData?.specialization_name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false") ? "39vh" : '32vh' }} className="eMed_createapt_right1" emed_tid="doc_demographics_appointment_details_paper">
                <Typography className='eMed_refdoc_title' emed_tid="doc_demographics_appointment_details_title">{t("Appointment Details")}</Typography>
                <Box className="eMed_createapt_right1_box" emed_tid="doc_demographics_appointment_details_box">
                  {/* {this.renderDropdown("Specialization", "0vw", states.spcInfo, "selectedSpecId")} */}
                  {/* {this.props.is_Nurse ? this.renderDropdown("Nurse", "0vw", states.NurseList, "selectedNurseId") :
                    this.renderDropdown("Doctor", "0vw", states["filteredDocList"].length > 0 ? states.filteredDocList : states.doctorList, "selectedDocId")} */}
                  {userData?.has_telemedicine ? null : this.renderDateTimeFilter()}
                  {this.renderDropdown("Patient Tag", "1vw", states.tagDetails, "selectedTagId")}
                  {this.renderDropdown("Appointment Type", "1vw", states.AppointmentTypeList, "selectedAppointTypeId")}
                  {userData?.has_telemedicine ? this.renderDateTimeFilter() : null}
                  {(userData?.specialization_name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false") ? this.renderDropdown("Optometrist", "1vw", states.OpthometristList, "selectedOptometrist") : null}
                </Box>
                <Autocomplete
                  inputProps={{ maxLength: 250 }}
                  options={states.POVList}
                  getOptionLabel={(options) => options}
                  onChange={(e, value) => {
                    this.setState({
                      purposeOfVisit: value
                    })
                  }}
                  clearIcon={false}
                  size='small'
                  sx={{ m: '1vw', width: '29vw' }}
                  value={states.purposeOfVisit}
                  emed_tid="doc_demographics_purpose_of_visit_autocomplete"
                  renderInput={(params) => <TextField sx={{ width: "28.5vw" }} onChange={(event) => {
                    this.setState({
                      purposeOfVisit: event.target.value
                    })
                  }}
                    {...params}
                    placeholder="Purpose Of Visit *"
                    emed_tid="doc_demographics_purpose_of_visit_input"
                  />}
                />

              </Paper>
              : null
          }
          <Paper elevation={2} sx={{ height: (patientCreate) ? "38vh" : '72vh' }} className="eMed_createapt_right2" emed_tid="doc_demographics_identity_proof_paper">
            <Typography className='eMed_refdoc_title' emed_tid="doc_demographics_identity_proof_title">{t("Identity Proof")}</Typography>
            {this.renderIdentityProof("Aadhaar", "aadharProof", "aadhar_card_number",this.state.duplicateAadharProof, "aadharProofImg")}
            {this.renderIdentityProof("PAN", "panProof", "pancard_number",this.state.duplicatePanProof, "panProofImg")}
            {this.renderIdentityProof("Passport", "passportProof", "passport_number",this.state.duplicatePassportProof, "passportProofImg")}
            {this.renderIdentityProof("Ration", "rationProof", "ration_card_number",this.state.duplicateRationProof, "rationProofImg")}
            {this.renderIdentityProof("DL", "dlProof", "dl_number",this.state.duplicateDlProof, "dlProofImg")}
          </Paper>
        </Stack>
      )
    } catch (e) {
      this.errorMessage(e)
    }
  }

  async getS3Key(doc_key, stateKey) {
      try {
        const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));
        if (response.data.status === "success") {
          const fileUrl = response.data.data; // Your S3 Signed URL
  
          // Fetch the file as a blob
          const fileResponse = await fetch(fileUrl);
          const blob = await fileResponse.blob();
  
          // Create an object URL for the blob
          const objectUrl = URL.createObjectURL(blob);
   
  

  
         
          this.setState({ [stateKey]: objectUrl });
        }
      } catch (e) {
        this.setState({
          isErrorMsg: true,
          isErrorMsgText: "Error fetching S3 URL"
        });
      }
    }

    fetchAndConvertToBase64 = async (url) => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const blob = await response.blob();
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
          reader.onloadend = () => resolve(reader?.result);
          reader.onerror = () => reject(reader?.error);
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error('Error fetching or converting file:', error);
      }
    }

  dataURItoBlob = (dataURI) => {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  sendDocuments(key) {
    let states = this.state;
    if (states[key] === "" || states[key] === null) {
      return "None"
    }
    else if (states[key] === "delete") {
      return "delete"
    }
    else {
      if (typeof (states[key]) === "string") {
        if (key === "patient_img") {
          if (states[key].includes("https://s3-ap-south-1.amazonaws.com")) {
            return "None"
          }
          else if (states[key]?.includes("amazonaws.com")) {
            return "None"
          }
          else {
            return this.dataURItoBlob(states[key])
          }
        } else {
          return "None"
        }
      }
      else {
        return states[key]
      }
    }
  }

  GetAppointmentDetails(id) {
    try {
      const { history } = this.props;
      RestAPIService.getAll(Serviceurls.FO_GET_APPOINMENT_DETAILS + "?appointment_id=" + id).
        then((response) => {
          if (response.data.status === "success") {
            setCachevalue(JSON.stringify(response.data.data), "patientData")
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  postDoctorPatientData = (METHOD) => {
    try {
      let states = this.state
      let date = new Date(states.dob)

      let Dob = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
      const dataForm = new FormData();
      let userData = JSON.parse(localGetItem("loggedInUserInfo"))
      let clinicId = userData?.clinic_id ? userData?.clinic_id : getCachevalue('SelectedDoctorClinic')
      let fromDemographic = getCachevalue('updatePatient')

      dataForm.append("first_name", states.first_name === null ? "" : CommonValidation.removeSpace(states.first_name))
      dataForm.append("last_name", states.surname === null ? "" : CommonValidation.removeSpace(states.surname))
      dataForm.append("middle_name", states.middle_name === null ? "" : CommonValidation.removeSpace(states.middle_name))
      dataForm.append("father_husband_name", states.father_husband_name === null ? "" : CommonValidation.removeSpace(states.father_husband_name))
      dataForm.append("father_husband_age", states.father_husband_age === null ? "" : CommonValidation.removeSpace(states.father_husband_age))
      dataForm.append("gender", states.gender === null ? "" : states.gender)
      dataForm.append("title", states.title === null ? "" : states.title)
      dataForm.append("occupation", states.occupation === null ? "" : CommonValidation.removeSpace(states.occupation))
      dataForm.append("dob", Dob === null ? "" : Dob)
      dataForm.append("approx_dob", Dob === null ? "" : Dob)
      dataForm.append("marital_status", states.marital_status === null ? "" : CommonValidation.removeSpace(states.marital_status))
      dataForm.append("mobile_number", states.mobile_no === null ? "" : CommonValidation.removeSpace(states.mobile_no))
      dataForm.append("mobile_number_2", "")
      dataForm.append("email", states.email_id === null ? "" : CommonValidation.removeSpace(states.email_id))
      dataForm.append("address_line_1", states.address_1 === null ? "" : CommonValidation.removeSpace(states.address_1))
      dataForm.append("address_line_2", states.address_2 === null ? "" : CommonValidation.removeSpace(states.address_2))
      dataForm.append("pincode", states.pin_code === null ? "" : CommonValidation.removeSpace(states.pin_code))
      dataForm.append("city_name", states.city === null ? "" : CommonValidation.removeSpace(states.city))
      dataForm.append("state_name", states.state_code === null ? "" : CommonValidation.removeSpace(states.AllStates.find((item) => (item.isoCode === states.state_code))?.name))
      dataForm.append("country", states.country_code === null ? "" : CommonValidation.removeSpace(states.AllCountry.find((item) => (item.isoCode === states.country_code))?.name))
      dataForm.append("reffered_by", states.referredBy === null ? "" : CommonValidation.removeSpace(states.referredBy))
      dataForm.append("referral_source", states.referralSource === null ? "" : CommonValidation.removeSpace(states.referralSource))
      dataForm.append("id_no", states.employee_id === null ? "" : CommonValidation.removeSpace(states.employee_id))
      dataForm.append("employer_id", states.employer_id === null ? "" : CommonValidation.removeSpace(states.employer_id))
      dataForm.append("document", states.docDocument === null ? "" : this.sendDocuments("docDocument"))
      dataForm.append("aadhar", (states.aadharProof !== null || states.aadharProofImgCap !== null) ? this.sendDocuments(states.aadharProofImgCap ? "aadharProofImgCap" : "aadharProof") : "")
      dataForm.append("pan", (states.panProof !== null || states.panProofImgCap !== null) ? this.sendDocuments(states.panProofImgCap ? "panProofImgCap" : "panProof") : "")
      dataForm.append("passport", (states.passportProof !== null || states.passportProofImgCap !== null) ? this.sendDocuments(states.passportProofImgCap ? "passportProofImgCap" : "passportProof") : "" )
      dataForm.append("ration_card", (states.rationProof !== null || states.rationProofImgCap !== null) ? this.sendDocuments(states.rationProofImgCap ? "rationProofImgCap" : "rationProof") : "")
      dataForm.append("dl", (states.dlProof !== null || states.dlProofImgCap !== null) ? this.sendDocuments(states.dlProofImgCap ? "dlProofImgCap" : "dlProof") : "")
      dataForm.append("photo", !states.patient_img ? "" : this.sendDocuments("patient_img"))
      dataForm.append("face_data", !states.patient_img ? "" : this.sendDocuments("patient_img"))
      dataForm.append("pancard_number", states.pancard_number === null ? "" : CommonValidation.removeSpace(states.pancard_number))
      dataForm.append("ration_card_number", states.ration_card_number === null ? "" : CommonValidation.removeSpace(states.ration_card_number))
      dataForm.append("dl_number", states.dl_number === null ? "" : CommonValidation.removeSpace(states.dl_number))
      dataForm.append("passport_number", states.passport_number === null ? "" : CommonValidation.removeSpace(states.passport_number))
      dataForm.append("aadhar_card_number", states.aadhar_card_number === null ? "" : CommonValidation.removeSpace(states.aadhar_card_number))
      dataForm.append("caretaker_name", states.emergency_contact_person === null ? "" : CommonValidation.removeSpace(states.emergency_contact_person))
      dataForm.append("caretaker_mobile", states.emergency_contact_mobile === null ? "" : CommonValidation.removeSpace(states.emergency_contact_mobile))
      dataForm.append("caretaker_relationship", states.relationship === null ? "" : CommonValidation.removeSpace(states.relationship))
      dataForm.append("receive_email", states.receive_email === null ? "" : states.receive_email)
      dataForm.append("receive_whatsapp", states.receive_whatsapp === null ? "" : CommonValidation.removeSpace(states.receive_whatsapp))
      dataForm.append("receive_sms", states.receive_sms === null ? "" : states.receive_sms)
      dataForm.append("insurance_company_name", states.insurance_company_name === null ? "" : CommonValidation.removeSpace(states.insurance_company_name))
      dataForm.append("policy_number", states.policy_number === null ? "" : CommonValidation.removeSpace(states.policy_number))
      dataForm.append("guardian", states.guardian === null ? "" : CommonValidation.removeSpace(states.guardian))
      dataForm.append("mother_name", states.mother_name === null ? "" : CommonValidation.removeSpace(states.mother_name))
      dataForm.append("mother_age", states.mother_age === null ? "" : CommonValidation.removeSpace(states.mother_age))
      dataForm.append('clinic_id', clinicId)
      dataForm.append('relationship_label',states.selectedFatHusName === '' ? '' : states.selectedFatHusName)
      dataForm.append('blood_group', states.blood_group === '' ? '' : states.blood_group)
      dataForm.append('rchid',states.rchid ? CommonValidation.removeSpace(states.rchid) : '')
      

      if (fromDemographic && this.state.SelectedPatientID && this.state.PatientTypeConfig) {
        dataForm.append('patient_type', states.patient_type === null ? '' : (states.patient_type === "new_patient" ? 1 : states.patient_type === "review_patient" ? 2 : states.patient_type === "old_patient" ? 3 : null))
      }

      if (METHOD === 'POST') {
        this.LoaderFunction(true)
        let patientId = this.props.history?.location?.state?.patientId
        if (patientId || this.state.doctorPatientId) {
          dataForm.append('patient_id', states.SelectedPatientID)
          this.setState({ DisableBtn: true })
          RestAPIService.updateWithOutId(dataForm, Serviceurls.DOC_PATIENT_CREATION)
            .then((response) => {
              if (response.data.status === 'success') {
                this.LoaderFunction(false)
                // this.getPatientDemographics(response?.data?.data?.patient_id)
                // this.successMessage(response?.data?.message)

                if (getCachevalue("DoctorPatientData")) {
                  let patientDetails = getCachevalue("DoctorPatientData")
                  let updatedData = JSON.parse(patientDetails)
                  updatedData["patient_type"] = response.data?.patient_type ? response.data?.patient_type : states?.patient_type
                  setCachevalue(JSON.stringify(updatedData), "DoctorPatientData")
                }

                this.setState({
                  SelectedPatientID: patientId || this.state.doctorPatientId || states.SelectedPatientID,
                  DisableBtn: false
                }, () => this.postDoctorAppointmentCreate(patientId ? patientId : this.state.doctorPatientId))
              }
            }).catch((e) => {
              this.setState({ DisableBtn: false })
              if (e?.response?.data?.message) {
                this.LoaderFunction(false)
                this.errorMessage(e.response.data.message)
              } else {
                this.LoaderFunction(false)
                this.errorMessage(e.message)
              }
            })
        } else {
          this.setState({ DisableBtn: true })
          RestAPIService.create(dataForm, Serviceurls.DOC_PATIENT_CREATION)
            .then((response) => {
              if (response.data.status === 'success') {
                this.LoaderFunction(false)
                if ((states.insurance_company_name != "" && states.insurance_company_name != null) && states.NewInsurance) {
                  this.postNewInsurance()
                }
                let patient_id = response.data.data
                this.setState({
                  SelectedPatientID: patient_id?.patient_id,
                  DisableBtn: false
                }, () => {
                  this.postDoctorAppointmentCreate(patient_id?.patient_id)
                })
              }
            }).catch((error) => {
              this.setState({ DisableBtn: false })
              if (error?.response?.data?.message) {
                this.LoaderFunction(false)
                this.errorMessage(error.response?.data?.message)
              } else {
                this.LoaderFunction(false)
                this.errorMessage(error.message)
              }
            })
        }

      } else {
        dataForm.append('patient_id', states.SelectedPatientID)
        this.LoaderFunction(true)
        this.setState({ DisableBtn: true })
        RestAPIService.updateWithOutId(dataForm, Serviceurls.DOC_PATIENT_CREATION)
          .then((response) => {
            if (response.data.status === 'success') {
              this.LoaderFunction(false)
              this.getPatientDemographics(response?.data?.data?.patient_id)
              this.setState({ DisableBtn: false })
              this.successMessage(response?.data?.message)
            }
          }).catch((e) => {
            this.setState({ DisableBtn: false })
            if (e?.response?.data?.message) {
              this.LoaderFunction(false)
              this.errorMessage(e.response.data.message)
            } else {
              this.LoaderFunction(false)
              this.errorMessage(e.message)
            }
          })
      }
    } catch (error) {
      this.LoaderFunction(false)
      this.errorMessage(error.message)
    }
  }

  postDoctorAppointmentCreate = (id) => {
    try {
      var states = this.state
      let { history } = this.props;

      var AptDateTime = new Date(states.appointmentDateTime)

      var AptDate = DateTime.fromJSDate(AptDateTime).toFormat('yyyy-MM-dd')

      var Aptime = DateTime.fromJSDate(AptDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
      let clinicId = getCachevalue('SelectedDoctorClinic')
      let TransID = this.props.history?.location?.state?.transferID
      let FollowupID = this.props.history?.location?.state?.followupID
      let loginData = JSON.parse(localGetItem('loggedInUserInfo'))

      var data = {
        patient_id: id,
        // doctor_id: states.selectedDocId?.doctor_id ? states.selectedDocId?.doctor_id : null,
        // speciality_id: states.selectedSpecId?.id ? states.selectedSpecId?.id : null,
        purpose_of_visit: states.purposeOfVisit,
        patient_tag_id: states.selectedTagId?.id,
        appointment_date: AptDate,
        appointment_start_time: Aptime,
        patient_appointment_type: states.selectedAppointTypeId === null ? null : states.selectedAppointTypeId?.id,
        nurse_id: states.selectedNurseId?.staff_id ? states.selectedNurseId?.staff_id : null,
        request_id: this.state.RequestedPatientData?.id ? this.state.RequestedPatientData?.id : null,
        clinic_id: +clinicId,
        doctor_id:loginData?.doctor_id,
        speciality_id:loginData?.specialization_id,
        optometrist_id: (loginData?.specialization_name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false") ? this.state.selectedOptometrist?.id : null,
      }
      if (TransID) {
        data["transfer_id"] = TransID
      }
      if (FollowupID) {
        data["followup_id"] = FollowupID
      }
      this.setState({ DisableBtn: true })
      RestAPIService.create(data, Serviceurls.DOC_PATIENT_APPOINTMENT)
        .then((response) => {
          if (response.data.status === 'success') {
            clearCachevalue('DoctorPatientData')
            clearCachevalue('AppRequestPatientData')
            this.LoaderFunction(false)
            this.setState({ doctorPatientId: null, DisableBtn: false })
            history.push({ pathname: "/DoctorHome", state: { NewAppointmentCreated: true, NewMessage: response.data?.message } })
          }
        }).catch((error) => {
          this.setState({ DisableBtn: false })
          if (error?.response?.data?.message) {
            this.LoaderFunction(false)
            this.errorMessage(error.response.data.message)
          } else {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.LoaderFunction(false)
      this.errorMessage(error.message)
    }
  }

  MandatoryCheck() {
    let states = this.state;
    let MandatoryCount = +(states.mandotory_count)
    let flag = false;
    for (let i = 0; i < MandatoryCount; i++) {
      if (CommonValidation.removeSpace(states[states.layoutData[i].field_name]) === "" || states[states.layoutData[i].field_name] === null) {
        flag = false
        this.errorMessage(`${states.layoutData[i].label} is Mandatory !`)
        break
      } else if(states.layoutData[i].field_name === 'father_husband_name' && states[states.layoutData[i].field_name] !== '' && states['selectedFatHusName'] === ''){
        flag = false
        this.errorMessage('Select Father/Spouse Releationship')
        break;
      } else {
        flag = true
      }
    }
    return flag
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  Validation() {
    let userData = JSON.parse(localGetItem("loggedInUserInfo"))
    let states = this.state;
    let Email = (states.MandatoryLabels.includes("Email ID") || states.email_id !== "") ? CommonValidation.emailValidation(states.email_id) : true;
    Email = states.email_id == null ? true : true;
    let Corporate = (states.employer_id === "" || states.employer_id === null) ? true : (states.employee_id !== "" && states.employee_id !== null)
    let Insurance = (states.insurance_company_name === "" || states.insurance_company_name === null) ? true : (states.policy_number !== "" && states.policy_number !== null)
    if (this.state.rchError) return this.errorMessage("Invalid RCH ID") 
    if (this.MandatoryCheck()) {
      let fromDoctorUpdate = this.props.history?.location?.state?.doctorUpdate ? this.props.history?.location?.state?.doctorUpdate : getCachevalue('updatePatient')
      if (fromDoctorUpdate) {
        if (states.mobile_no.length === 10 && Email && Corporate && Insurance && states.dob != "Invalid Date" && (this.state.dob < new Date() && this.state.dob > new Date("1872-01-01")) && (CommonValidation.removeSpace(this.state.purposeOfVisit) !== "")) {
          this.postDoctorPatientData('PUT')
        } else {
          if (states.mobile_no.length !== 10) { this.errorMessage("Invalid Mobile Number") }
          else if (!Email) { this.errorMessage("Invalid Email ID") }
          else if (states.dob == "Invalid Date") { this.errorMessage("Invalid Date of Birth") }
          else if (!(this.state.dob < new Date() && this.state.dob > new Date("1872-01-01"))) { this.errorMessage("Invalid Date of Birth") }
          else if (!Corporate) { this.errorMessage("Employee ID No is empty") }
          else if (!Insurance) { this.errorMessage("Insurance Policy No is empty") }
          else if ((CommonValidation.removeSpace(this.state.purposeOfVisit) === "") || (CommonValidation.removeSpace(this.state.purposeOfVisit) === undefined)) { this.errorMessage("Enter Purpose of Visit") }
        }
      } else {
        if (states.mobile_no.length === 10 && Email && Corporate && Insurance && states.dob != "Invalid Date" && (this.state.dob < new Date() && this.state.dob > new Date("1872-01-01")) && ((CommonValidation.removeSpace(this.state.purposeOfVisit) !== "") && (CommonValidation.removeSpace(this.state.purposeOfVisit) !== undefined)) && (userData?.specialization_name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false" ? states.selectedOptometrist : true)) {
          this.postDoctorPatientData("POST")
        } else {
          if (states.mobile_no.length !== 10) { this.errorMessage("Invalid Mobile Number") }
          else if (states.dob == "Invalid Date") { this.errorMessage("Invalid Date of Birth") }
          else if (!Email) { this.errorMessage("Invalid Email ID") }
          else if (!(this.state.dob < new Date() && this.state.dob > new Date("1872-01-01"))) { this.errorMessage("Invalid Date of Birth") }
          else if (!Corporate) { this.errorMessage("Employee ID No is empty") }
          else if (!Insurance) { this.errorMessage("Insurance Policy No is empty") }
          else if (userData?.specialization_name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false" && !states?.selectedOptometrist) { this.errorMessage("Select Optometrist") }
          else if ((CommonValidation.removeSpace(this.state.purposeOfVisit) === "") || (CommonValidation.removeSpace(this.state.purposeOfVisit) === undefined)) { this.errorMessage("Enter Purpose of Visit") }
          else if ((DateTime.fromJSDate(states.appointmentDateTime).toFormat('yyyy-MM-dd') === "Invalid DateTime" || !(new Date((new Date).getFullYear(), (new Date).getMonth() - 2, 1) < states.appointmentDateTime && new Date((new Date).getFullYear(), (new Date).getMonth() + 3, 0) > states.appointmentDateTime))) { this.errorMessage("Invalid Appointment Date & Time !") }
        }
      }
    }
  }

  printOPCard = () => {
    try {
      let patientDetails = getCachevalue('DoctorPatientData')
      let appointmentId = JSON.parse(patientDetails)
      let clinicId = getCachevalue('SelectedDoctorClinic')
      RestAPIService.getAll(Serviceurls.OP_CARD_PRINT + "?patient_id=" + appointmentId?.patient_id + "&appointment_id=" + appointmentId?.appointment_id + "&clinic_id=" + clinicId + "&header=false")
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  ClearData() {
    clearCachevalue("OP_CreateAppointment_PatientId");
    clearCachevalue("AppRequestPatientData");
    this.setState({
      referredBy: "",
      referralSource: "",
      mobile_no: "",
      first_name: "",
      age: "",
      dob: null,
      gender: "",
      title: "",
      middle_name: "",
      surname: "",
      address_1: "",
      address_2: "",
      city: "",
      state: "",
      country: "",
      pin_code: "",
      employer_id: null,
      employee_id: "",
      email_id: "",
      marital_status: "",
      father_husband_name: "",
      father_husband_age: "",
      occupation: "",
      emergency_contact_person: "",
      emergency_contact_mobile: "",
      relationship: "",
      docDocument: null,
      aadharProof: null,
      panProof: null,
      passportProof: null,
      rationProof: null,
      dlProof: null,
      aadharProofImg: null,
      panProofImg: null,
      passportProofImg: null,
      rationProofImg: null,
      dlProofImg: null,
      aadharProofImgCap: null,
      panProofImgCap: null,
      passportProofImgCap: null,
      rationProofImgCap: null,
      dlProofImgCap: null,
      selectedDocId: null,
      selectedSpecId: null,
      selectedTagId: null,
      appointmentDateTime: new Date(),
      purposeOfVisit: null,
      pancard_number: "",
      ration_card_number: "",
      dl_number: "",
      passport_number: "",
      aadhar_card_number: "",
      insurance_company_name: null,
      policy_number: "",
      guardian: "",
      patient_img: null,
      temp_patient_img: null,
      selectedAppointTypeId: this.state.AppointmentTypeList.find((item) => (item.appoinment_type === "Walk in Appointment" && item.is_active === true)),
      filteredDocList: [],
      isPatientCreated: false,
      SelectedPatientID: "",
      mother_name: "",
      mother_age: "",
      RequestedPatientData: {},
      manuallyChanged: false,
      selectedFatHusName:'',
      blood_group: '',
      ccn_number: '',
      caretaker_id: '',
      selectedOptometrist: null,
      rchid:'',
    },() => {
      let city_name = localGetItem('city_name')
      let state_name = localGetItem('state_name')
      let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === state_name?.toLowerCase())
      let stateList = State.getStatesOfCountry(List?.countryCode)
      let cityList = City.getCitiesOfState(List?.countryCode, List?.isoCode)
      this.setState({ city: city_name, state_code: List?.isoCode, AllStates: stateList, cityName: cityList })
    })
  }

  PreviewPopClose() { this.setState({ SelectedDocSRC: null }) }

  SameNumberPatientPop() {
    let { t } = this.props;
    return (
      <Modal open={true}>
        <Box className="eMed_MobileNum_Main">
          <Box component={'div'} className="eMed_MobileNum_Header">
            <Typography variant='h6'>{"Patient List"}</Typography>
            <IconButton onClick={() => { this.setState({ SameMobileNumPatients: [] }) }} marginRight={'4vw'} emed_tid="doc_demographics_patient_list_close_btn">
              <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
            </IconButton>
          </Box>
          <Box component={'div'} className="eMed_MobileNum_wrapper">
            {
              this.state.SameMobileNumPatients.length > 0 ?
                this.state.SameMobileNumPatients.map((list) => {
                  let PatientFullName = `${list.first_name} ${list.last_name}`
                  list["patient_name"] = PatientFullName
                  list["patient_mobile_number"] = list.mobile_number
                  list["patient_photo_url"] = list.photo_url
                  return (
                    <Box>
                      <Box className="eMed_Patient_Num_Search_pop">
                        <CommonPatientDetails data={list} />
                        {this.props.isFromIP ?          // For IP Appointment
                          <Tooltip title={t("CreateAppointment")} arrow>
                            <IconButton disabled={list.is_admitted} onClick={() => {
                              this.props.history.push({ pathname: "/IPHome/CreateAppointment", state: { SelectedPatientDetails: list, PatientClicked: true } })
                            }} position="end" emed_tid={`doc_demographics_ip_create_appointment_btn_${list.patient_id}`}>
                              <PersonAddAlt1Icon sx={{ color: list.is_admitted ? Colors.disableLabelColor : Colors.themeDark }} />
                            </IconButton>
                          </Tooltip>
                          :                           // For OP Appointment
                          ((list.appointment_date === "" || list.appointment_date !== "") || list.appointment_status === "Cancelled") ? <Tooltip title={t("CreateAppointment")} arrow>
                            <IconButton onClick={() => {
                              setCachevalue(list.patient_id, "OP_CreateAppointment_PatientId")
                              this.setState({
                                SelectedPatientID: list.patient_id,
                                doctorPatientId: list?.patient_id,
                                SameMobileNumPatients: []
                              }, () => { this.getPatientDemographics() })
                            }} position="end" emed_tid={`doc_demographics_op_create_appointment_btn_${list.patient_id}`}>
                              <PersonAddAlt1Icon color='primary' />
                            </IconButton>
                          </Tooltip> : <Typography fontSize={'0.8vw'}>{list.appointment_date}</Typography>
                        }
                      </Box>
                      <Divider />
                    </Box>
                  )
                }) : null
            }
          </Box>
        </Box>
      </Modal>
    )
  }

  onClickChipHandler = (item) => {
    this.setState({ selectedSlot: item })
  }

  OpenAppointmentSlotPopUP = () => {
    return (
      <Box>
        <Modal open={true}>
          <Box className="eMed_WebCamPop_Main" sx={{ height: "40vh" }}>
            <Box component={'div'} className="eMed_WebCam_Header">
              <Typography fontWeight={600} fontSize={'1.1vw'} color={Colors.SecondaryText}>
                Select Slot
              </Typography>
              <Button onClick={() => { this.setState({ slotPopup: false }) }} emed_tid="doc_demographics_slot_popup_close_btn">
                <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
              </Button>
            </Box>
            <Box component={'div'} style={{ display: "flex", flexWrap: "wrap", width: "90%", alignItems: "center", margin: "1vw", marginLeft: "2.5vw", height: "25vh", overflow: "scroll" }}>
              {typeof (this.state.slotList) === 'object' && !Array.isArray(this.state.slotList) ?
                // When slotList is an object (not array)
                Object.entries(this.state.slotList).map(([period, timeSlots]) => (
                  timeSlots.length > 0 && (
                    <div key={period}>
                      <Typography fontSize={'1vw'} fontWeight={'bold'} sx={{ marginBottom: '0.5vw' }}>
                        {`${period} :`}
                      </Typography>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5vw', marginBottom: '1vw' }}>
                        {timeSlots.map((item, index) => (
                          <Chip
                            className='eMed_chip'
                            size="medium"
                            label={this.convertTo12Hour(item)}
                            variant={item === this.state.selectedSlot ? 'contained' : 'outlined'}
                            key={`${period}-${index}`}
                            onClick={() => { this.onClickChipHandler(item) }}
                            color={'primary'}
                            sx={{ width: "5vw", borderRadius: "0.6vw" }}
                            clickable
                            emed_tid={`doc_demographics_slot_chip_${period}_${index}`}
                          />
                        ))}
                      </div>
                    </div>
                  )
                ))
                :
                // When slotList is an array or empty
                this.state.slotList?.length > 0 ? this.state.slotList.map((item, index) => (
                  <Chip
                    className='eMed_chip'
                    size="medium"
                    label={this.convertTo12Hour(item)}
                    variant={item === this.state.selectedSlot ? 'contained' : 'outlined'}
                    key={index}
                    onClick={() => { this.onClickChipHandler(item) }}
                    color={'primary'}
                    sx={{ width: "5vw", borderRadius: "0.6vw" }}
                    clickable
                    emed_tid={`doc_demographics_slot_chip_${index}`}
                  />
                )) :
                  <Typography sx={{ height: "5vw", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "red" }}>
                    {"Doctor Schedule not available"}
                  </Typography>
              }
            </Box>
            <Box component={'div'} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end", paddingLeft: "1vw", paddingRight: "3vw" }}>
              <Button variant='outlined' size='small' id="eMed_Config_btn" style={{ marginRight: "0.5vw" }} onClick={() => { this.setState({ selectedSlot: "" }) }} emed_tid="doc_demographics_slot_clear_btn">Clear</Button>
              <Button variant='contained' size='small' id="eMed_Config_btn" onClick={() => {
                let AppointTime = new Date(this.state.appointmentDateTime)
                if (this.state.selectedSlot) {
                  AppointTime.setHours(this.state.selectedSlot?.split(":")[0]);
                  AppointTime.setMinutes(this.state.selectedSlot?.split(":")[1]);
                }
                this.setState({
                  appointmentDateTime: (AppointTime && this.state.selectedSlot) ? AppointTime : this.state.appointmentDateTime,
                  slotPopup: false
                })
              }} emed_tid="doc_demographics_slot_select_btn">Select</Button>
            </Box>
          </Box>
        </Modal>
      </Box>
    )
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }
  render() {
    const { t, fromViewGraphics } = this.props
    let update = this.props.fromOT ? true : this.props.history.location?.state?.doctorUpdate ? this.props.history.location?.state?.doctorUpdate : getCachevalue('updatePatient')
    return (
      <Box component={"div"} className={fromViewGraphics ? 'eMed_bill_ipContainer' : 'eMed_bill_container'} emed_tid="doc_demographics_container">
        <Grid container className={fromViewGraphics ? 'eMed_bill_ipContent' : 'eMed_bill_content'} emed_tid="doc_demographics_grid_container">
          <Grid container className={fromViewGraphics ? 'eMed_bill_ipContent1' : 'eMed_bill_content1'} spacing={fromViewGraphics ? 1 : 2} emed_tid="doc_demographics_grid_content">
            <Grid item xs={8} emed_tid="doc_demographics_grid_left">
              {this.renderCreateAppointmentLeft()}
            </Grid>
            <Grid item xs={4} emed_tid="doc_demographics_grid_right">
              {this.renderCreateAppointmentRight()}
            </Grid>
          </Grid>
          <Box className={fromViewGraphics ? 'eMed_bill_content2 eMed_bill_Ipcontent2' : 'eMed_bill_content2'} emed_tid="doc_demographics_footer">
            {this.props.fromOT ? null : <Button variant='outlined' size="small" id="eMed_Config_btn" sx={{ mr: '1vw' }} onClick={() => { this.ClearData() }} emed_tid="doc_demographics_clear_btn">{t("Clear")}</Button>}
            {this.props.fromOT ? null : <Button disabled={this.state.DisableBtn || getCachevalue('DoctorUserChanged') === 'true'} variant='contained' size="small" id="eMed_Config_btn" sx={{ ml: '1vw' }} onClick={() => { this.Validation() }} emed_tid="doc_demographics_submit_btn">{update ? 'Update' : "Create Appointment"}</Button>}
          </Box>
        </Grid>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="doc_demographics_error_toast"
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="doc_demographics_success_toast"
          />
          : null}
        {this.state.ProfilePicClicked ? this.OpenWebCamPopUP() : null}
        {this.state.slotPopup ? this.OpenAppointmentSlotPopUP() : null}
        {this.state.imgCapClked && this.OpenWebCamIdPopUP()}
        {this.state.SelectedDocSRC !== null ?
          <CommonImgPreviewPop src={this.state.SelectedDocSRC} title={"Document Preview"} PopClose={this.PreviewPopClose.bind(this)} emed_tid="doc_demographics_doc_preview" /> : null}
        {
          this.state.pdfPreview ?
            <PrintPreviewPop
              Data={this.state.pdfData}
              Title={t("PDF Preview")}
              ClosePopUp={this.ClosePopUp.bind(this)}
              history={this.props.history}
              emed_tid="doc_demographics_pdf_preview"
            /> : null
        }
        {this.state.SameMobileNumPatients.length > 0 ? this.SameNumberPatientPop() : null}
        <Loader loaderOpen={this.state.isLoader} />
      </Box>
    )
  }
}

export default withTranslation()(CreateApppointment);